import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const vegetablesIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  tomato: (props) => {
    const { width = 64, height = 64, ...restProps } = props;
    return (
      <svg
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        {...restProps}
      >
        <path
          d="m45 26.553c0 10.217-9.4 20.447-21 20.447s-21-10.23-21-20.447 9.4-15.553 21-15.553 21 5.335 21 15.553z"
          fill="#ff1f1f"
        />
        <path
          d="m26.34 9a9.561 9.561 0 0 0 .66 1 1.993 1.993 0 0 1 -2 2h-1.12a1.967 1.967 0 0 1 -1.78-1.09 9.329 9.329 0 0 1 -.68-2c-.71-3.05-.63-7.29.92-7.91h3.5a8.532 8.532 0 0 0 .5 8z"
          fill="#00ac0d"
        />
        <path
          d="m28 9c1.81-.05 4.95.53 6 2 1.93 2.7 5.72 1.12 5.99 1.01-2 3.72-9.99 1.99-9.99 1.99 1 4.67-1 7-1 7-3 0-6-6-6-6-2 .93-5 6-5 6-4-2.8-2-6-2-6a7.943 7.943 0 0 1 -7-4c5 0 4 .07 7-1a12.133 12.133 0 0 1 5-1l.42-.09a9.329 9.329 0 0 0 .68 2 1.967 1.967 0 0 0 1.78 1.09h1.12a1.993 1.993 0 0 0 2-2 9.561 9.561 0 0 1 -.66-1z"
          fill="#070"
        />
        <path
          d="m45 26.553c0 10.217-9.4 20.447-21 20.447s-21-10.23-21-20.447 9.4-15.553 21-15.553 21 5.335 21 15.553z"
          fill="#ff1f1f"
        />
        <path
          d="m7 21.553a13.965 13.965 0 0 1 1.274-5.936 13.436 13.436 0 0 0 -5.274 10.936c0 10.217 9.4 20.447 21 20.447a21.541 21.541 0 0 0 18.251-10.815 20.9 20.9 0 0 1 -14.251 5.815c-11.6 0-21-10.23-21-20.447z"
          fill="#cb0303"
        />
        <path
          d="m26.34 9a9.561 9.561 0 0 0 .66 1 1.993 1.993 0 0 1 -2 2h-1.12a1.967 1.967 0 0 1 -1.78-1.09 9.329 9.329 0 0 1 -.68-2c-.71-3.05-.63-7.29.92-7.91h3.5a8.532 8.532 0 0 0 .5 8z"
          fill="#008906"
        />
        <path
          d="m28 9c1.81-.05 4.95.53 6 2 1.93 2.7 5.72 1.12 5.99 1.01-2 3.72-9.99 1.99-9.99 1.99 1 4.67-1 7-1 7-3 0-6-6-6-6-2 .93-5 6-5 6-4-2.8-2-6-2-6a7.943 7.943 0 0 1 -7-4c5 0 4 .07 7-1a12.133 12.133 0 0 1 5-1l.42-.09a9.329 9.329 0 0 0 .68 2 1.967 1.967 0 0 0 1.78 1.09h1.12a1.993 1.993 0 0 0 2-2 9.561 9.561 0 0 1 -.66-1z"
          fill="#070"
        />
        <path
          d="m18 23s2.553-5.07 4.812-6c0 0 3.388 6 6.776 6a10.044 10.044 0 0 0 1.412-8s5.309 1.648 8.721.613a16.916 16.916 0 0 0 -1.559-1.092 4.94 4.94 0 0 1 -1.448-.388 18.519 18.519 0 0 1 -6.714-.133c1 4.67-1 7-1 7-3 0-6-6-6-6-2 .93-5 6-5 6-4-2.8-2-6-2-6a7.919 7.919 0 0 1 -4.559-1.369 18.451 18.451 0 0 0 -2.307 1.327 10.221 10.221 0 0 0 4.866 1.042s-.518 4.2 4 7z"
          fill="#aa1313"
        />
        <path
          d="m31 15a10.119 10.119 0 0 1 .264 3.04c5.847 2.415 9.736 6.951 9.736 13.513a18.307 18.307 0 0 1 -1.326 6.694 22.558 22.558 0 0 0 2.577-2.062q-.333.567-.7 1.116l.042-.06.141-.215c.139-.214.273-.429.4-.647.049-.082.1-.164.146-.247.123-.21.241-.421.356-.635.049-.091.1-.182.146-.274q.16-.311.312-.627c.047-.1.1-.2.141-.3.094-.2.182-.41.269-.616.046-.108.092-.216.135-.325.08-.2.155-.4.229-.605.042-.115.085-.23.124-.346.069-.2.131-.4.193-.6.036-.12.075-.239.109-.36.057-.2.107-.4.157-.6.031-.124.065-.248.093-.373.046-.2.084-.4.123-.6.024-.125.052-.25.073-.376.036-.2.063-.411.091-.616.017-.122.037-.243.051-.364.026-.222.043-.444.06-.667.008-.105.02-.211.027-.316q.029-.492.029-.983a13.636 13.636 0 0 0 -6.837-12.031 16.892 16.892 0 0 1 1.558 1.091c-3.41 1.039-8.719-.609-8.719-.609z"
          fill="#ff5d03"
        />
        <path
          d="m39.721 15.613a16.892 16.892 0 0 0 -1.558-1.091c-.3-.183-.584-.371-.894-.54-.182.055-.364.11-.554.152-.21.046-.423.084-.638.117-.116.018-.231.033-.348.047s-.262.03-.393.041c-.116.011-.231.022-.347.03-.208.013-.414.021-.62.026-.127 0-.251 0-.376 0s-.228 0-.341 0-.242 0-.362-.009c-.189-.007-.375-.017-.556-.029l-.343-.026-.291-.031-.308-.031c-.137-.015-.268-.031-.393-.047-.107-.013-.2-.026-.3-.04l-.238-.035-.194-.03-.259-.044-.144-.026-.146-.028-.056-.01-.062-.009a11.215 11.215 0 0 1 .217 3.63c.357.128.7.268 1.047.41a10.119 10.119 0 0 0 -.264-3.04s5.309 1.648 8.721.613z"
          fill="#cb0303"
        />
        <g fill="#00ac0d">
          <path d="m36.261 12.465c.11.023.219.041.329.056-.11-.015-.22-.033-.329-.056z" />
          <path d="m38.94 12.35c.081-.021.16-.041.234-.062-.074.021-.153.042-.234.062z" />
          <path d="m36.719 12.538c.122.013.243.021.364.025-.121-.004-.242-.012-.364-.025z" />
          <path d="m38.513 12.445c.116-.023.228-.047.335-.072-.107.027-.219.049-.335.072z" />
          <path d="m37.619 12.559a6.722 6.722 0 0 0 .861-.108 6.929 6.929 0 0 1 -.861.108z" />
          <path d="m35.355 12.154c.1.046.19.09.287.127-.096-.037-.192-.081-.287-.127z" />
          <path d="m26.967 10.329a1.782 1.782 0 0 0 .033-.329 1.983 1.983 0 0 1 -.033.329z" />
          <path d="m30.026 14.144c-.01-.049-.015-.1-.026-.144.011.05.013.093.023.143z" />
          <path d="m34.491 11.553c.09.084.18.167.274.239-.094-.072-.184-.155-.274-.239z" />
          <path d="m39.287 12.255.161-.049z" />
          <path d="m34.919 11.9c.09.062.181.122.274.174-.093-.054-.184-.114-.274-.174z" />
          <path d="m35.805 12.34c.1.034.2.064.3.089-.098-.029-.199-.055-.3-.089z" />
          <path d="m37.609 12.559c-.142.008-.288.011-.435.008.148.003.293 0 .435-.008z" />
          <path d="m34.366 11.438a3.805 3.805 0 0 1 -.366-.438 3.892 3.892 0 0 0 .366.438z" />
          <path d="m39.576 12.164.085-.03z" />
        </g>
        <path
          d="m35.642 12.281c.054.021.109.04.163.059-.054-.019-.105-.04-.163-.059z"
          fill="#00ce23"
        />
        <path
          d="m35.193 12.072c.054.029.108.055.162.082-.055-.027-.108-.054-.162-.082z"
          fill="#00ce23"
        />
        <path d="m26.9 10.608a2 2 0 0 0 .07-.279 2.371 2.371 0 0 1 -.07.279z" fill="#00ce23" />
        <path
          d="m36.109 12.429c.051.013.1.025.152.036-.051-.011-.101-.023-.152-.036z"
          fill="#00ce23"
        />
        <path
          d="m34.765 11.792c.05.039.1.071.154.106-.052-.035-.104-.067-.154-.106z"
          fill="#00ce23"
        />
        <path
          d="m36.59 12.521c.043.006.086.013.129.017-.043-.004-.086-.011-.129-.017z"
          fill="#00ce23"
        />
        <path d="m38.848 12.373.092-.023z" fill="#00ce23" />
        <path d="m38.48 12.451.033-.006z" fill="#00ce23" />
        <path d="m39.8 12.084-.139.05c.052-.018.1-.034.139-.05z" fill="#00ce23" />
        <path d="m39.448 12.206.128-.042z" fill="#00ce23" />
        <path d="" fill="#00ce23" />
        <path d="m37.174 12.567c-.03 0-.061 0-.091 0 .03-.003.061 0 .091 0z" fill="#00ce23" />
        <path d="m39.174 12.288.113-.033z" fill="#00ce23" />
        <path
          d="m34.491 11.553c-.041-.04-.085-.074-.125-.115.04.041.084.075.125.115z"
          fill="#00ce23"
        />
        <path
          d="m39.8 12.084c-.041.016-.087.032-.139.05l-.085.03-.128.042-.161.049-.113.033c-.074.021-.153.041-.234.062l-.092.023c-.107.025-.219.049-.335.072l-.033.006a6.722 6.722 0 0 1 -.861.108h-.01c-.142.008-.287.011-.435.008-.03 0-.061 0-.091 0-.121 0-.242-.012-.364-.025-.043 0-.086-.011-.129-.017-.11-.015-.219-.033-.329-.056-.051-.011-.1-.023-.152-.036-.1-.025-.2-.055-.3-.089-.054-.019-.109-.038-.163-.059-.1-.037-.192-.081-.287-.127-.054-.027-.108-.053-.162-.082-.093-.052-.184-.112-.274-.174-.052-.035-.1-.067-.154-.106-.094-.072-.184-.155-.274-.239-.041-.04-.085-.074-.125-.115a3.892 3.892 0 0 1 -.37-.442c-1.05-1.47-4.19-2.05-6-2h-1.66a9.561 9.561 0 0 0 .66 1 1.782 1.782 0 0 1 -.033.329 2 2 0 0 1 -.07.279c2.066 1.292 7.41 3.966 12.903 1.476z"
          fill="#00ce23"
        />
        <path
          d="m26.786 10.887-.012-.011a1.964 1.964 0 0 1 -1.21 1.034 1.975 1.975 0 0 0 1.222-1.023z"
          fill="#00ac0d"
        />
        <path
          d="m29.13 20.824c.417-.6 1.673-2.829.893-6.681a31.643 31.643 0 0 1 -3.992-1.065z"
          fill="#00ce23"
        />
        <path
          d="m39.8 12.084c-5.493 2.49-10.837-.189-12.9-1.476a2.052 2.052 0 0 1 -.111.279 2.051 2.051 0 0 1 -1.789 1.113h-1.12a2.024 2.024 0 0 1 -.939-.243 20.656 20.656 0 0 0 3.09 1.321 31.643 31.643 0 0 0 3.992 1.065c-.01-.05-.012-.093-.023-.143 0 0 7.99 1.73 9.99-1.99z"
          fill="#00ac0d"
        />
        <path
          d="m21.215 10.632a11.818 11.818 0 0 0 1.577 1.045 1.9 1.9 0 0 1 -.692-.767c-.1-.191-.179-.421-.264-.646-.185.123-.397.246-.621.368z"
          fill="#00ac0d"
        />
        <path d="m21.42 8.91c.068.29.147.558.23.816-.081-.263-.162-.526-.23-.816z" fill="#00ac0d" />
        <path
          d="m21.65 9.726c.059.19.121.365.186.538-.065-.172-.126-.353-.186-.538z"
          fill="#008906"
        />
        <path
          d="m21.215 10.632c.224-.122.436-.245.621-.368-.065-.173-.127-.348-.186-.538-.083-.258-.162-.526-.23-.816l-.42.09c-.462 0-.89.029-1.3.069a6.941 6.941 0 0 0 1.515 1.563z"
          fill="#00ac0d"
        />
        <path
          d="m23.88 12a2 2 0 0 1 -1.456-.623 9.58 9.58 0 0 0 -4.377 9.544c.376-.621 3.095-5.057 4.953-5.921l1-3z"
          fill="#008906"
        />
        <path
          d="m22.792 11.677c-.324-.18-.626-.366-.912-.557l-2.974 2.974a1 1 0 0 0 .192 1.565l.788.473a1 1 0 0 0 1.161-.094l3.958-3.35a19.3 19.3 0 0 1 -2.064-.931c-.05-.027-.101-.049-.149-.08z"
          fill="#025602"
        />
        <path
          d="m25 12h-1.12a1.872 1.872 0 0 1 -.492-.067 2.009 2.009 0 0 1 -.447-.176 19.3 19.3 0 0 0 2.064.931l1.995-1.688-.242-.061a1.986 1.986 0 0 1 -1.758 1.061z"
          fill="#016601"
        />
        <path
          d="m22.792 11.677a1.918 1.918 0 0 1 -.394-.331 1.8 1.8 0 0 1 -.3-.436v-.007l-.217.217c.286.191.588.377.912.557z"
          fill="#016601"
        />
        <path
          d="m27 10a9.561 9.561 0 0 1 -.66-1 8.532 8.532 0 0 1 -.5-8h-3.5a1.158 1.158 0 0 0 -.3.185c.291 4.967 2.397 8.815 4.96 8.815z"
          fill="#00ce23"
        />
        <ellipse
          cx="37"
          cy="20"
          fill="#f6fafd"
          rx="1.65"
          ry="2.297"
          transform="matrix(.707 -.707 .707 .707 -3.301 32.035)"
        />
        <ellipse
          cx="41"
          cy="21"
          fill="#f6fafd"
          rx=".825"
          ry="1.148"
          transform="matrix(.707 -.707 .707 .707 -2.836 35.157)"
        />
        <ellipse
          cx="31"
          cy="12"
          fill="#b3ffd2"
          rx=".825"
          ry="1.148"
          transform="matrix(.707 -.707 .707 .707 .599 25.445)"
        />
        <ellipse
          cx="37.746"
          cy="23.5"
          fill="#f6fafd"
          rx=".413"
          ry=".574"
          transform="matrix(.707 -.707 .707 .707 -5.558 33.588)"
        />
        <ellipse
          cx="28.746"
          cy="10.5"
          fill="#b3ffd2"
          rx=".413"
          ry=".574"
          transform="matrix(.707 -.707 .707 .707 .999 23.411)"
        />
        <ellipse
          cx="16"
          cy="42"
          fill="#aa1313"
          rx="1.65"
          ry="2.297"
          transform="matrix(.707 -.707 .707 .707 -25.019 23.629)"
        />
        <ellipse
          cx="12"
          cy="39"
          fill="#aa1313"
          rx=".825"
          ry="1.148"
          transform="matrix(.707 -.707 .707 .707 -24.069 19.921)"
        />
        <ellipse
          cx="13.746"
          cy="38.5"
          fill="#aa1313"
          rx=".413"
          ry=".574"
          transform="matrix(.707 -.707 .707 .707 -23.204 21.009)"
        />
      </svg>
    );
  },
  carrot: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m346.612 14.789c14.844-17.69 41.336-19.839 58.845-4.642 17.14 14.877 18.714 40.983 4.125 58.369l-95.943 114.34-18.776-15.756 35.216-41.969c4.966-5.918 4.579-14.574-.754-20.164-.081-.085-.162-.17-.242-.256-10.824-11.577-12.203-29.421-3.271-42.514 3.296-4.832 7.55-8.508 12.295-11.02-2.995-12.349-.288-25.907 8.505-36.388z"
                  fill="#8dc637"
                ></path>
                <path
                  d="m409.586 68.517-95.943 114.34-15.22-12.771 89.509-106.673c14.587-17.384 13.012-43.488-4.124-58.371-2.256-1.955-4.655-3.623-7.156-5.008 10.157-.414 20.493 2.899 28.81 10.112 17.136 14.883 18.711 40.987 4.124 58.371z"
                  fill="#82b732"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <g>
              <path
                d="m454.163 139.722c14.332-17.08 11.934-42.631-5.452-56.732-17.019-13.803-42.108-10.923-56.193 5.864l-105.231 125.409 18.13 15.213 46.598-55.533c4.795-5.715 13.09-6.797 19.3-2.664.094.063.189.125.284.187 12.823 8.351 30.022 6.67 40.974-4.017 4.042-3.944 6.825-8.606 8.417-13.538 12.244.776 24.683-4.071 33.173-14.189z"
                fill="#99d53b"
              ></path>
              <path
                d="m454.166 139.723c-8.489 10.116-20.933 14.969-33.172 14.186-1.597 4.935-4.378 9.591-8.417 13.537-10.961 10.693-28.155 12.372-40.981 4.018-.093-.062-.185-.124-.278-.185-6.212-4.131-14.505-3.049-19.306 2.668l-46.595 55.527-18.131-15.205 53.951-64.294c3.925-1.02 8.252-.381 11.868 2.019.093.062.185.124.278.185 12.826 8.355 30.03 6.665 40.981-4.018 2.423-2.367 4.393-4.991 5.927-7.776 1.838-3.339 5.285-5.501 9.077-5.885 9.992-1.011 19.619-5.762 26.584-14.071 10.137-12.074 11.899-28.392 5.913-41.898 2.39 1.216 4.687 2.699 6.851 4.461 17.379 14.103 19.779 39.651 5.45 56.731z"
                fill="#8dc637"
              ></path>
              <path
                d="m287.287 214.263 18.13 15.213 80.184-95.56c4.201-5.007 3.548-12.471-1.459-16.672-5.007-4.201-12.471-3.548-16.672 1.459z"
                fill="#bcea73"
              ></path>
              <path
                d="m416.058 111.959c-3.204 0-6.199-2.009-7.304-5.207-1.392-4.033.748-8.432 4.783-9.824l3.172-1.095c4.034-1.392 8.432.749 9.825 4.782 1.392 4.033-.748 8.432-4.783 9.824l-3.172 1.095c-.835.288-1.685.425-2.521.425z"
                fill="#82b732"
              ></path>
            </g>
            <g>
              <path
                d="m380.833 102.75c7.859-10.012 6.053-24.698-4.414-32.44-9.159-6.775-22.188-5.631-30.044 2.62-.052.055-.104.109-.155.164-2.596 2.781-6.679 3.7-10.061 1.956-14.697-7.58-33.188-4.286-44.264 8.914-10.715 12.77-11.093 30.764-2.04 43.837-3.45 8.861-1.094 19.302 6.595 25.753l.057.048c2.973 2.487 3.367 6.95.876 9.919l-29.157 34.748 19.061 15.994 93.56-111.501z"
                fill="#a3e440"
              ></path>
              <path
                d="m328.648 125.857-28.969 34.532c-.34.402-.701.762-1.102 1.082 1.02-2.72.278-5.903-2.071-7.871l-.062-.041c-2.328-1.957-4.162-4.275-5.501-6.799l25.868-30.833c1.978-2.359 2.926-5.347 2.658-8.417s-1.72-5.851-4.079-7.829c-3.266-2.74-3.688-7.613-.948-10.879 2.74-3.276 7.613-3.698 10.889-.958 5.511 4.636 8.901 11.136 9.529 18.317.629 7.18-1.576 14.174-6.212 19.696z"
                fill="#99d53b"
              ></path>
              <path
                d="m268.227 198.269 19.061 15.994 57.49-68.514c4.417-5.263 3.73-13.111-1.533-17.527-5.263-4.417-13.111-3.73-17.527 1.533z"
                fill="#dbf2b4"
              ></path>
            </g>
          </g>
        </g>
        <g>
          <path
            d="m49.037 497.123c-1.71-16.683.582-33.526 6.678-49.149 27.846-71.379 113.511-276.002 184.415-287.014 34.778-5.401 107.123 55.303 107.843 90.491 1.478 72.245-203.822 212.412-273.437 257.838-10.376 6.77-24.236.159-25.499-12.166z"
            fill="#fca62f"
          ></path>
          <path
            d="m74.534 509.292c-10.374 6.77-24.235.152-25.494-12.171-.446-4.3-.614-8.611-.524-12.909 1.11-.424 2.21-.972 3.262-1.662 69.612-45.422 274.909-185.591 273.428-257.837-.158-7.768-3.804-16.774-9.768-26.05 18.393 17.403 32.223 37.5 32.539 52.791 1.472 72.24-203.824 212.409-273.443 257.838z"
            fill="#fb9927"
          ></path>
        </g>
        <path
          d="m263.644 241.248c-1.525 1.823-3.719 2.761-5.924 2.761-1.751 0-3.513-.587-4.965-1.803l-59.823-50.396c3.688-3.956 7.366-7.603 11.054-10.889l58.71 49.449c3.266 2.739 3.688 7.612.948 10.878z"
          fill="#fcc16d"
        ></path>
        <path
          d="m262.19 288.713c-1.753 0-3.515-.593-4.963-1.808l-44.652-37.468c-3.269-2.742-3.695-7.616-.952-10.885 2.742-3.27 7.616-3.696 10.885-.952l44.652 37.468c3.269 2.742 3.695 7.616.952 10.885-1.528 1.822-3.717 2.76-5.922 2.76z"
          fill="#fb9927"
        ></path>
        <path
          d="m272.483 360.254c-3.781 3.492-7.644 6.974-11.579 10.467l-61.667-51.519c-3.266-2.74-3.698-7.613-.948-10.889 2.74-3.266 7.613-3.688 10.879-.948z"
          fill="#f98824"
        ></path>
        <path
          d="m171.381 387.595c-1.525 1.823-3.719 2.761-5.924 2.761-1.751 0-3.513-.587-4.965-1.803l-58.267-48.655c2.256-4.759 4.564-9.55 6.923-14.35l61.285 51.169c3.266 2.74 3.688 7.613.948 10.878z"
          fill="#fb9927"
        ></path>
        <path
          d="m144.104 415.81c-1.753 0-3.515-.593-4.963-1.808l-25.975-21.795c-3.269-2.742-3.695-7.616-.952-10.885 2.742-3.269 7.616-3.695 10.885-.953l25.975 21.795c3.269 2.743 3.695 7.617.952 10.885-1.528 1.822-3.717 2.761-5.922 2.761z"
          fill="#fcb44d"
        ></path>
        <g fill="#f98824">
          <path d="m209.769 365.233c-1.753 0-3.515-.593-4.963-1.808l-4.714-3.956c-3.269-2.742-3.695-7.616-.952-10.885 2.742-3.269 7.616-3.696 10.885-.952l4.714 3.956c3.269 2.742 3.695 7.616.952 10.885-1.528 1.822-3.717 2.76-5.922 2.76z"></path>
          <path d="m289.272 270.486c-1.753 0-3.515-.593-4.963-1.808l-4.714-3.956c-3.269-2.742-3.695-7.616-.952-10.885 2.742-3.269 7.616-3.696 10.885-.952l4.714 3.956c3.269 2.742 3.695 7.616.952 10.885-1.528 1.821-3.717 2.76-5.922 2.76z"></path>
        </g>
      </g>
    </svg>
  ),
  onion: (props) => (
    <svg viewBox="0 0 450 450" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="m59.38 343.417c2.362-3.071 7.087.472 4.725 3.543-8.741 11.575-2.835 21.497.472 33.545.945 3.78-4.725 5.433-5.67 1.654-4.251-14.647-10.157-24.569.473-38.742z"
          fill="#d1763c"
        ></path>
        <path
          d="m66.467 345.306c0-4.016 6.142-4.016 6.142 0v21.97c0 3.78-6.142 3.78-6.142 0z"
          fill="#d1763c"
        ></path>
        <g clipRule="evenodd" fillRule="evenodd">
          <path
            d="m32.686 295.225c-16.773-50.318-6.142-104.415 32.364-140.322 67.563-62.602 112.919-19.607 172.214-46.065 16.536-14.41 23.623-19.844 34.018-34.962 6.142-8.741 3.071-7.796 13.465-7.796 0-23.387-4.725-21.497 17.009-21.497v29.529c-7.796 17.481-13.465 29.529-20.788 42.286-14.646 25.749-9.922 33.781-1.181 62.129 19.371 63.783 23.151 113.864-3.307 152.37-14.883 21.497-34.726 39.687-77.012 54.333-49.138 17.008-138.67-5.434-166.782-90.005z"
            fill="#e9a876"
          ></path>
          <path
            d="m292.069 230.261c13.229 79.61-18.426 129.219-92.603 154.969-27.403 9.449-67.563 6.615-102.525-12.284 15.119-93.785 102.289-158.276 195.128-142.685z"
            fill="#e29a64"
          ></path>
          <path
            d="m378.531 359.717c-80.319 73.941-178.828 51.262-216.625-28.82-27.875-59.058 0-118.589 21.025-125.44 17.717-7.087 30.474-21.497 58.113-21.025 68.98.945 165.599 38.033 182.844 92.839 5.433 17.954-10.867 23.623-20.08 50.081 12.52 29.766 2.598 26.459-25.277 32.365z"
            fill="#efe7d9"
          ></path>
          <path
            d="m228.759 185.141c2.835-.236 8.977-.945 12.284-.709 68.98.945 165.599 38.033 182.844 92.839 5.197 16.772-8.977 22.915-18.426 45.593-5.906-22.678 8.741-26.222 6.851-37.561-12.757-70.87-142.921-92.131-177.411-91.895-4.488.001-4.252-8.031-6.142-8.267z"
            fill="#ebb892"
          ></path>
          <path
            d="m378.531 359.717c-132.763 122.132-281.59-26.931-214.263-136.779 25.041 109.848 119.298 143.866 244.501 125.912v.236c-2.363 6.851-12.757 7.087-30.238 10.631z"
            fill="#ebb892"
          ></path>
          <path
            d="m181.749 212.307c-20.552-22.678 26.694-31.891 41.577-33.781 4.725-.472 8.741 17.009 8.741 17.009-21.734 8.977-27.167 12.048-50.318 16.772z"
            fill="#ece8db"
          ></path>
        </g>
        <path
          d="m186.946 232.623c-.945-3.78 4.725-5.433 5.67-1.654 19.607 73.941 108.903 102.525 176.938 105.36 3.78 0 3.543 5.906-.236 5.906-70.87-2.834-162.056-32.836-182.372-109.612z"
          fill="#dfd2c1"
        ></path>
        <path
          d="m244.587 207.819c-3.78-.945-2.362-6.851 1.417-5.906 5.906 1.654 10.867 2.835 16.064 4.016 48.9 12.048 113.392 27.639 133.471 72.996 4.961 11.103-.236 20.316-.236 32.364 0 3.78-5.906 3.78-5.906 0 0-10.158 4.488-21.261.709-30.002-18.899-42.522-81.736-57.877-129.456-69.452-5.905-1.418-11.575-2.835-16.063-4.016z"
          fill="#dfd2c1"
        ></path>
        <path
          d="m206.789 224.828c-1.89-3.307 3.307-6.378 5.197-2.835 28.82 51.026 86.934 83.626 142.212 97.8 3.78 1.181 2.362 6.851-1.417 5.906-56.932-14.646-116.226-48.191-145.992-100.871z"
          fill="#dfd2c1"
        ></path>
        <path
          d="m227.814 216.087c-3.543-1.181-1.89-7.087 1.89-5.67 47.483 15.355 120.242 49.609 147.173 93.548 1.89 3.307-3.071 6.378-5.197 3.071-25.986-42.285-98.037-76.066-143.866-90.949z"
          fill="#dfd2c1"
        ></path>
        <path
          clipRule="evenodd"
          d="m145.841 150.414c7.796 8.741 3.78 23.387-9.213 32.6-13.229 9.449-30.002 9.686-37.797.945-8.032-8.977-3.78-23.623 9.213-32.836s29.766-9.685 37.797-.709z"
          fill="#ebbb97"
          fillRule="evenodd"
        ></path>
      </g>
    </svg>
  ),
  garlic: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <path
            clipRule="evenodd"
            d="m336.869 347.459c-60.897-90.651-148.044-207.304-99.14-323.214 4.06-4.556 9.979-6.849 15.898-6.818 10.63-.062 21.229 7.314 21.198 22.128v12.273c0 94.246 136.67 85.847 160.254 217.191-14.039 15.868-29.72 56.436-44.968 65.703-12.21 7.437-41.125 6.786-53.242 12.737z"
            fill="#fed1a3"
            fillRule="evenodd"
          ></path>
        </g>
        <g>
          <path
            clipRule="evenodd"
            d="m217.12 124.473c-30.991 32.758-90.618 83.213-90.618 165.496 0 80.3-5.052 128.337 36.136 144.174h-35.547-17.975c-80.36-10.289-116.557-84.019-107.849-154.122 17.758-142.873 161.959-131.406 161.959-228.193v-12.273c-.062-14.814 10.537-22.19 21.167-22.128 5.919-.031 11.839 2.262 15.898 6.818-1.55 3.099 5.021 6.88 5.021 11.281 0 39.484 32.943 66.602 11.808 88.947z"
            fill="#fed1a3"
            fillRule="evenodd"
          ></path>
        </g>
        <g>
          <path
            clipRule="evenodd"
            d="m495.047 198.605c.775 180.62-71.31 289.867-273.682 272.48-15.434-10.041-27.923-22.5-36.074-36.942-.124-.186-.217-.403-.341-.589-6.539-11.808-10.165-24.917-10.165-39.05 0-11.653-.186-12.676 12.613-15 1.89-.341 3.905-.682 5.981-1.085 14.814-2.665 34.493-6.353 57.24-12.18 30.278-7.779 66.042-19.37 102.983-37.5 12.087-5.95 24.297-12.583 36.507-19.99 15.248-9.298 30.929-23.864 44.968-39.732 20.268-22.872 37.127-48.44 44.41-64.649 4.465-9.978 10.198-9.637 15.56-5.763z"
            fill="#ffe5c1"
            fillRule="evenodd"
          ></path>
        </g>
        <g>
          <path
            clipRule="evenodd"
            d="m353.604 328.74c-36.941 18.13-72.705 29.721-102.983 37.5-22.747 5.827-42.427 9.514-57.24 12.18l-5.981 1.085c-12.799 2.324-12.613 3.347-12.613 15 0 14.132 3.626 27.242 10.165 39.05.124.186.217.403.341.589h-1.828-20.826c-41.187-15.837-81.63-63.874-81.63-144.174 0-82.283 59.658-132.738 90.618-165.496 22.252-23.492 26.218-52.903 26.218-74.132v-14.816c-.031-4.401.899-8.182 2.448-11.281 3.75-7.407 11.25-11.095 18.719-11.064 7.5-.031 14.969 3.657 18.719 11.064 1.581 3.099 2.479 6.88 2.479 11.281v14.814c0 21.229 3.936 50.641 26.187 74.132 30.991 32.758 90.618 83.213 90.618 165.496-.002 13.885-1.211 26.809-3.411 38.772z"
            fill="#fed1a3"
            fillRule="evenodd"
          ></path>
        </g>
        <g>
          <path
            clipRule="evenodd"
            d="m261.592 163.367c31.518 35.61 70.505 72.552 68.707 165.775-.062 3.502-.062 6.973-.217 10.351 7.748-3.285 15.619-6.88 23.522-10.754 2.2-11.963 3.409-24.886 3.409-38.771 0-82.283-59.627-132.738-90.618-165.496-22.252-23.492-26.187-52.903-26.187-74.132v-14.814c0-4.401-.899-8.182-2.479-11.281-3.75-7.407-11.219-11.095-18.719-11.064-1.023 0-2.076.062-3.099.217 1.395 2.975 2.169 6.508 2.169 10.599v14.814c0 60.279 1.395 76.953 43.512 124.556z"
            fill="#ffbc85"
            fillRule="evenodd"
          ></path>
        </g>
        <g>
          <path
            clipRule="evenodd"
            d="m162.637 434.143c-41.187-15.837-81.63-63.874-81.63-144.174 0-82.283 59.658-132.738 90.618-165.496 22.252-23.492 26.218-52.903 26.218-74.132v-14.815c-.031-4.401.899-8.182 2.448-11.281-4.06-4.556-9.979-6.849-15.898-6.818-4.215 6.26-2.169 12.707-2.169 22.314v14.783c0 21.26-13.14 44.907-35.361 68.399-30.991 32.758-90.649 91.24-90.649 173.523 0 71.374 31.952 117.242 67.994 137.697h2.882z"
            fill="#ffbc85"
            fillRule="evenodd"
          ></path>
        </g>
        <g>
          <path
            clipRule="evenodd"
            d="m221.365 471.085c192.361 6.849 263.702-103.172 273.682-272.48 10.537 5.393 15.65 38.988 16.797 78.037 4.339 149.164-82.56 212.759-169.211 221.189-13.667 1.333-27.303 1.302-40.567 0-19.586-1.89-38.398-6.508-55.257-13.481-9.111-3.75-17.634-8.213-25.444-13.265z"
            fill="#fed1a3"
            fillRule="evenodd"
          ></path>
        </g>
      </g>
    </svg>
  ),
  cucumber: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="XMLID_1_">
        <g id="XMLID_2989_">
          <path
            id="XMLID_519_"
            d="m463.7 16.9c-55-55-199.3 92.5-289.3 182.5s-217.2 224.4-151 290.6 164.4-74.3 278.8-188.6 207.9-238.1 161.5-284.5z"
            fill="#399349"
          ></path>
          <path
            id="XMLID_1097_"
            d="m463.7 16.9c-3.9-3.9-8.3-6.8-13.1-8.8 24.9 52.9-63.3 167.1-169.5 273.2-107.2 107.2-200.2 237.3-265.9 198.7 2.3 3.5 5 6.8 8.2 9.9 66.2 66.2 164.4-74.3 278.8-188.6s207.9-238 161.5-284.4z"
            fill="#2b6e38"
          ></path>
          <g id="XMLID_518_">
            <path
              id="XMLID_1093_"
              d="m126.6 299.6-7.5-6.6c35.1-40.3 68.8-74.9 85.8-91.9l7.1 7.1c-16.9 16.9-50.5 51.2-85.4 91.4z"
              fill="#2b6e38"
            ></path>
          </g>
          <g id="XMLID_516_">
            <path
              id="XMLID_1092_"
              d="m436.7 111.1-8-6c33.8-45 44.8-74.1 31.9-84.2-17.1-13.4-48.1-2.4-92.2 32.8l-6.2-7.8c48.9-39 83.1-49.7 104.6-32.8 24.6 19.2-5.4 65.1-30.1 98z"
              fill="#2b6e38"
            ></path>
          </g>
          <g id="XMLID_515_">
            <path
              id="XMLID_1091_"
              d="m287.9 279.3-7.4-6.7c10.7-11.8 22.6-24.6 35.2-38.2 15.8-17 32.1-34.5 48.3-52.5l7.4 6.7c-16.2 18-32.6 35.6-48.4 52.6-12.5 13.6-24.4 26.4-35.1 38.1z"
              fill="#2b6e38"
            ></path>
          </g>
          <g id="XMLID_511_">
            <path
              id="XMLID_1090_"
              d="m41.6 502.2c-8.6 0-15.9-2.9-21.7-8.6-20.3-20.1-6.9-62 41.1-128.1l8.1 5.9c-43.4 59.6-58 99.4-42.2 115 4 4 9 5.9 15.2 5.7 25.4-.4 68.5-33.2 131.5-100.2l7.3 6.9c-65.9 70-110 102.8-138.7 103.3-.2 0-.4.1-.6.1z"
              fill="#2b6e38"
            ></path>
          </g>
          <g id="XMLID_510_">
            <path
              id="XMLID_1089_"
              d="m377.7 142-7.5-6.6c27.2-30.7 48.6-56.2 63.8-75.7 16.9-21.8 22.7-32.1 24.6-36.8-3.7 2-11 6.9-24.7 18.5-13.9 11.8-31.8 28.3-54.9 50.5l-6.9-7.2c25.4-24.4 44.7-42.1 59.3-54.2 24-19.9 31.1-21.5 35.7-17.3 5.6 5 3.9 14.5-21.7 48.1-15.4 20.2-38.2 47.4-67.7 80.7z"
              fill="#2b6e38"
            ></path>
          </g>
          <g id="XMLID_509_">
            <path
              id="XMLID_1084_"
              d="m27.3 496.7c-.2 0-.4 0-.5 0-3.9-.2-6.1-2.1-7.4-3.7-4.7-6.1-5.3-18.1 26.1-60.8 18.4-25.1 45.2-57.2 79.7-95.6l7.4 6.7c-33.8 37.6-61.1 70.3-79.1 94.8-27.9 38-26.8 47.1-26.3 48.6 1.1.1 6.1-.6 20.4-11.7 10.6-8.2 24.6-20.9 41.6-37.7 31.3-30.9 68.4-71.2 103.7-109.8l7.4 6.7c-34.5 37.8-70.8 77.2-101.9 108.1-48.1 47.6-63.4 54.4-71.1 54.4z"
              fill="#2b6e38"
            ></path>
          </g>
          <g id="XMLID_507_">
            <path
              id="XMLID_1083_"
              d="m180.8 291.1-7.3-6.9c17.4-18.4 34.7-36.2 50-51.6 10.4-10.4 22.5-22.6 35.3-35.5 25.1-25.3 53.5-53.9 81.1-81.1l7 7.1c-27.6 27.2-55.9 55.8-81 81-12.8 12.9-25 25.2-35.4 35.6-15.1 15.3-32.3 33-49.7 51.4z"
              fill="#2b6e38"
            ></path>
          </g>
          <circle id="XMLID_502_" cx="317" cy="397" fill="#b3d34c" r="75"></circle>
          <path
            id="XMLID_1099_"
            d="m392 397c0-17.9-6.2-34.2-16.7-47.1-33.4 7.6-58.3 37.4-58.3 73.1 0 17.9 6.2 34.2 16.7 47.1 33.4-7.6 58.3-37.4 58.3-73.1z"
            fill="#9abd2d"
          ></path>
          <g fill="#c3dc74">
            <path
              id="XMLID_487_"
              d="m307 368.1v23.1l-20 11.5c-4.4 2.5-10-.6-10-5.7v-.1c0-14.8 8-27.7 20-34.6 4.4-2.5 10 .7 10 5.8z"
            ></path>
            <path
              id="XMLID_486_"
              d="m357 397v.1c0 5.1-5.6 8.2-10 5.7l-20-11.5v-23.1c0-5.1 5.6-8.4 10-5.8 12 6.8 20 19.8 20 34.6z"
            ></path>
            <path
              id="XMLID_485_"
              d="m337 420.1c4.4 2.5 4.5 8.9.1 11.5-5.9 3.4-12.8 5.4-20.1 5.4s-14.2-2-20.1-5.4c-4.4-2.6-4.3-9 .1-11.5l20-11.5z"
            ></path>
          </g>
          <ellipse
            id="XMLID_631_"
            cx="282.8"
            cy="135"
            fill="#47b85c"
            rx="18.2"
            ry="50"
            transform="matrix(.745 .667 -.667 .745 162.198 -154.23)"
          ></ellipse>
          <circle id="XMLID_506_" cx="432" cy="432" fill="#b3d34c" r="75"></circle>
          <path
            id="XMLID_505_"
            d="m442 460.8v-23.1l20-11.5c4.4-2.5 10 .6 10 5.7v.1c0 14.8-8 27.7-20 34.6-4.4 2.6-10-.7-10-5.8z"
            fill="#c3dc74"
          ></path>
          <path
            id="XMLID_504_"
            d="m392 432v-.1c0-5.1 5.6-8.2 10-5.7l20 11.5v23.1c0 5.1-5.6 8.4-10 5.8-12-6.9-20-19.8-20-34.6z"
            fill="#c3dc74"
          ></path>
          <path
            id="XMLID_503_"
            d="m412 408.9c-4.4-2.5-4.5-8.9-.1-11.5 5.9-3.4 12.8-5.4 20.1-5.4s14.2 2 20.1 5.4c4.4 2.6 4.3 9-.1 11.5l-20 11.5z"
            fill="#c3dc74"
          ></path>
        </g>
        <g id="XMLID_2617_">
          <g id="XMLID_849_">
            <path
              id="XMLID_1437_"
              d="m61.7 512c-15.5 0-29.6-6.2-41.8-18.5-16.8-16.8-23-38.7-18.4-65.1 3.8-22.2 15.5-48.3 34.7-77.6 33.8-51.6 84.7-105 134.7-155l7.4-7.4c20.3-20.3 43.4-43.4 67.2-66l6.9 7.3c-23.8 22.5-46.7 45.5-67 65.9l-7.4 7.4c-49.7 49.6-100.2 102.5-133.5 153.3-18.4 28.1-29.6 53-33.2 73.8-4 23.3 1.1 41.8 15.6 56.3 10.7 10.7 22.4 15.8 35.7 15.5 45.5-.8 105.4-65.3 168.8-133.6 21.7-23.3 44.1-47.5 67.2-70.6 62.9-62.9 111.5-120.6 140.4-166.7 16.3-26.1 26.5-48.7 30.3-67.1 3.9-19.2 1-33.4-9-43.4-29.2-29.2-92.5 2.2-193.5 95.9l-6.8-7.3c46.8-43.3 84.6-72.8 115.7-90.2 41.4-23.1 72.3-24.9 91.7-5.4 23.3 23.3 16.6 64.6-19.8 122.9-29.3 46.8-78.3 105.1-141.8 168.6-23 23-45.3 47.1-67 70.3-67.8 72.8-126.3 135.7-176 136.7-.4 0-.8 0-1.1 0z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_100_">
            <path
              id="XMLID_1436_"
              d="m126.6 299.6-7.5-6.6c35.1-40.3 68.8-74.9 85.8-91.9l7.1 7.1c-16.9 16.9-50.5 51.2-85.4 91.4z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_143_">
            <path
              id="XMLID_1435_"
              d="m436.7 111.1-8-6c33.8-45 44.8-74.1 31.9-84.2-17.1-13.4-48.1-2.4-92.2 32.8l-6.2-7.8c48.9-39 83.1-49.7 104.6-32.8 24.6 19.2-5.4 65.1-30.1 98z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_90_">
            <path
              id="XMLID_1434_"
              d="m287.9 279.3-7.4-6.7c10.7-11.8 22.6-24.6 35.2-38.2 15.8-17 32.1-34.5 48.3-52.5l7.4 6.7c-16.2 18-32.6 35.6-48.4 52.6-12.5 13.6-24.4 26.4-35.1 38.1z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_81_">
            <path
              id="XMLID_1433_"
              d="m41.6 502.2c-8.6 0-15.9-2.9-21.7-8.6-20.3-20.1-6.9-62 41.1-128.1l8.1 5.9c-43.4 59.6-58 99.4-42.2 115 4 4 9 5.9 15.2 5.7 25.4-.4 68.5-33.2 131.5-100.2l7.3 6.9c-65.9 70-110 102.8-138.7 103.3-.2 0-.4.1-.6.1z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_156_">
            <path
              id="XMLID_1432_"
              d="m377.7 142-7.5-6.6c27.2-30.7 48.6-56.2 63.8-75.7 16.9-21.8 22.7-32.1 24.6-36.8-3.7 2-11 6.9-24.7 18.5-13.9 11.8-31.8 28.3-54.9 50.5l-6.9-7.2c25.4-24.4 44.7-42.1 59.3-54.2 24-19.9 31.1-21.5 35.7-17.3 5.6 5 3.9 14.5-21.7 48.1-15.4 20.2-38.2 47.4-67.7 80.7z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_120_">
            <path
              id="XMLID_1431_"
              d="m27.3 496.7c-.2 0-.4 0-.5 0-3.9-.2-6.1-2.1-7.4-3.7-4.7-6.1-5.3-18.1 26.1-60.8 18.4-25.1 45.2-57.2 79.7-95.6l7.4 6.7c-33.8 37.6-61.1 70.3-79.1 94.8-27.9 38-26.8 47.1-26.3 48.6 1.1.1 6.1-.6 20.4-11.7 10.6-8.2 24.6-20.9 41.6-37.7 31.3-30.9 68.4-71.2 103.7-109.8l7.4 6.7c-34.5 37.8-70.8 77.2-101.9 108.1-48.1 47.6-63.4 54.4-71.1 54.4z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_145_">
            <path
              id="XMLID_1430_"
              d="m180.8 291.1-7.3-6.9c17.4-18.4 34.7-36.2 50-51.6 10.4-10.4 22.5-22.6 35.3-35.5 25.1-25.3 53.5-53.9 81.1-81.1l7 7.1c-27.6 27.2-55.9 55.8-81 81-12.8 12.9-25 25.2-35.4 35.6-15.1 15.3-32.3 33-49.7 51.4z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_154_">
            <path
              id="XMLID_1423_"
              d="m432 512c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0-150c-38.6 0-70 31.4-70 70s31.4 70 70 70 70-31.4 70-70-31.4-70-70-70z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_301_">
            <path
              id="XMLID_1384_"
              d="m448.7 472.5c-2 0-4-.5-5.8-1.6-3.7-2.1-5.9-5.9-5.9-10.1v-23.1c0-1.8 1-3.4 2.5-4.3l20-11.5c3.7-2.1 8-2.1 11.7 0 3.6 2.1 5.8 5.8 5.8 10v.1c0 16-8.6 30.9-22.5 39-1.8 1-3.8 1.5-5.8 1.5zm-1.7-31.9v20.2c0 .8.5 1.3.9 1.5.3.2.9.4 1.7 0 10.7-6.3 17.4-17.9 17.4-30.3v-.1c0-.7-.4-1.1-.8-1.3-.3-.1-1-.5-1.7 0z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_232_">
            <path
              id="XMLID_1381_"
              d="m415.3 472.5c-2 0-4-.5-5.8-1.6-13.9-8-22.5-23-22.5-39v-.1c0-4.2 2.2-7.9 5.8-10 3.7-2.1 8.1-2.1 11.7 0l20 11.5c1.5.9 2.5 2.5 2.5 4.3v23.1c0 4.2-2.2 8-5.9 10.1-1.8 1.2-3.8 1.7-5.8 1.7zm-16.6-42.2c-.4 0-.7.1-.9.2-.4.2-.8.6-.8 1.3v.1c0 12.5 6.7 24.1 17.5 30.3.7.4 1.3.2 1.7 0 .3-.2.9-.6.9-1.5v-20.2l-17.5-10.1c-.4 0-.7-.1-.9-.1z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_231_">
            <path
              id="XMLID_1378_"
              d="m432 425.4c-.9 0-1.7-.2-2.5-.7l-20-11.5c-3.7-2.1-5.8-5.9-5.9-10.1 0-4.2 2.1-7.9 5.7-10 6.8-4 14.7-6.1 22.6-6.1s15.8 2.1 22.6 6.1c3.6 2.1 5.7 5.8 5.7 10s-2.2 8-5.9 10.1l-20 11.5c-.6.5-1.4.7-2.3.7zm-17.5-20.9 17.5 10.1 17.5-10.1c.8-.4.9-1.2.9-1.5 0-.4-.1-1-.8-1.4-5.3-3.1-11.4-4.7-17.6-4.7s-12.3 1.6-17.6 4.7c-.6.4-.8.9-.8 1.4.1.4.1 1.1.9 1.5z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_223_">
            <path
              id="XMLID_1376_"
              d="m317 477c-44.1 0-80-35.9-80-80s35.9-80 80-80c25.3 0 48.6 11.6 63.9 31.8l-8 6c-13.4-17.7-33.7-27.8-55.9-27.8-38.6 0-70 31.4-70 70s31.4 70 70 70c15 0 29.4-4.7 41.5-13.6l5.9 8.1c-13.8 10.1-30.2 15.5-47.4 15.5z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_185_">
            <path
              id="XMLID_1373_"
              d="m283.7 408.6c-2 0-4-.5-5.9-1.6-3.6-2.1-5.8-5.8-5.8-10 0-16 8.6-30.9 22.5-39 3.6-2.1 8-2.1 11.7 0s5.9 5.9 5.9 10.1v23.1c0 1.8-1 3.4-2.5 4.3l-20 11.5c-1.9 1.1-3.9 1.6-5.9 1.6zm16.6-42.2c-.2 0-.5.1-.8.2-10.8 6.2-17.5 17.9-17.5 30.3v.1c0 .7.4 1.1.8 1.3.3.2 1 .5 1.7 0l17.5-10.1v-20.2c0-.8-.5-1.3-.9-1.5-.1 0-.4-.1-.8-.1z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_172_">
            <path
              id="XMLID_1369_"
              d="m350.3 408.6c-2 0-4-.5-5.9-1.6l-20-11.5c-1.5-.9-2.5-2.5-2.5-4.3v-23.1c0-4.2 2.2-8 5.9-10.1s8-2.1 11.7 0c13.9 8 22.5 23 22.5 39v.1c0 4.2-2.2 7.9-5.8 10-1.8 1-3.9 1.5-5.9 1.5zm-18.3-20.3 17.5 10.1c.8.4 1.5.1 1.7 0 .4-.2.8-.6.8-1.3v-.1c0-12.5-6.7-24.1-17.5-30.3-.7-.4-1.3-.2-1.7 0-.3.2-.9.6-.9 1.5v20.1z"
              fill="#1d4925"
            ></path>
          </g>
          <g id="XMLID_171_">
            <path
              id="XMLID_1366_"
              d="m317 442c-8 0-15.8-2.1-22.6-6.1-3.6-2.1-5.7-5.8-5.7-10s2.2-8 5.9-10.1l20-11.5c1.5-.9 3.5-.9 5 0l20 11.5c3.7 2.1 5.8 5.9 5.9 10.1 0 4.2-2.1 7.9-5.7 10-7 4-14.8 6.1-22.8 6.1zm0-27.7-17.5 10.1c-.8.4-.9 1.2-.9 1.5 0 .4.1 1 .8 1.4 5.3 3.1 11.4 4.7 17.6 4.7s12.3-1.6 17.6-4.7c.6-.4.8-.9.8-1.4 0-.3-.1-1-.9-1.5z"
              fill="#1d4925"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  eggplant: (props) => (
    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m12.7 45c-5.4 0-9.7-4.4-9.7-9.7 0-7.6 4.6-9.3 9.4-11 2.5-.9 5.2-1.8 7.6-3.7 1.8-1.3 3.4-2.9 5-4.6 2.1-2.3 3.7-3.6 4-4 .2-.3 2.8-1.5 3-1.3 0 0 4.2-1.4 7 1.3s2 7.7 2 8c-1 10.4-14 25-28.3 25z"
        fill="#4a148c"
      />
      <path
        d="m43 3 2 2s-2.2 3.8-4 6c1.4 1.8 3.1 4.8 1 10-2.1-.6-4-5-4-5s-1.2 1.5-5 2c-.3-3.7 1-5 1-5s-4.6.4-6-1c0 0 2.8-5.3 10-3 2.8-2 5-6 5-6z"
        fill="#4caf50"
      />
      <path
        d="m7 35s-.6-3.5 5-6 12-4.7 17-11"
        fill="none"
        stroke="#9575cd"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  ),
  broccoli: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <path d="m218.276 222.049h73.239v263.185h-73.239z" fill="#95d528" />
        </g>
      </g>
      <g>
        <g>
          <path d="m265.161 222.049h26.354v263.185h-26.354z" fill="#89c627" />
        </g>
      </g>
      <g>
        <path
          d="m411.263 263.072-46.96 41.166c-28.231 24.749-49.483 56.438-61.815 91.564 2.992-28.714 9.498-57.013 19.369-84.148l32.48-89.28-29.284-10.654-32.48 89.281c-11.04 30.347-18.212 61.965-21.345 94.105l-1.669 17.12c-1.004 10.301-9.501 18.508-19.85 18.566-11.105.062-20.126-8.921-20.126-20.011v-130.5h-31.161v95.515c-8.894-19.199-19.983-37.39-33.097-54.135l-42.276-53.981-24.533 19.213 42.276 53.981c25.941 33.125 42.988 72.62 49.297 114.216l5.349 35.263c.952 6.273 6.344 10.909 12.689 10.909h94.37c6.286 0 11.646-4.552 12.665-10.755l8.703-53.015c6.97-42.457 28.626-81.46 60.981-109.823l46.96-41.166z"
          fill="#b9ea6a"
        />
      </g>
      <g>
        <g>
          <path
            d="m411.263 263.072-46.96 41.166c-28.231 24.749-49.483 56.438-61.815 91.564 1.484-14.24 3.834-28.377 7.028-42.321-18.911 24.382-31.648 53.291-36.691 84.012l-8.703 53.015c-1.018 6.203-6.379 10.755-12.665 10.755h51.04c6.286 0 11.647-4.552 12.665-10.755l8.703-53.015c6.97-42.457 28.626-81.46 60.981-109.823l46.959-41.166z"
            fill="#a1e42c"
          />
        </g>
      </g>
      <g>
        <path
          d="m430.526 150.353c-3.002-.047-5.968.067-8.889.332-11.716 1.065-21.91-7.778-22.627-19.52-.016-.27-.034-.54-.053-.81-2.884-40.848-35.818-73.768-76.668-76.617-7.067-.493-13.959-.093-20.576 1.093-7.953 1.426-16.003-1.933-20.62-8.563-14.993-21.528-39.936-35.597-68.157-35.53-28.223.066-53.114 14.247-68.009 35.846-4.29 6.221-11.746 9.599-19.243 8.651-3.462-.438-6.99-.661-10.572-.653-45.724.107-82.705 37.261-82.597 82.985.012 5.28.525 10.44 1.486 15.441 1.37 7.123-1.057 14.458-6.458 19.301-17.218 15.439-27.934 37.974-27.529 62.999.704 43.587 35.76 79.583 79.316 81.358 21.412.873 41.093-6.395 56.234-18.947 7.417-6.149 18.023-6.13 25.473-.021 14.895 12.213 34.117 19.334 55.016 18.693 42.099-1.291 76.865-34.609 79.971-76.613.047-.637.087-1.273.119-1.908.543-10.658 9.528-18.761 20.199-18.756h.231c2.805-.007 5.577-.153 8.31-.432 11.194-1.145 21.077 7.486 21.646 18.724.031.603.068 1.207.111 1.813 2.965 41.181 36.454 74.195 77.674 76.565 48.947 2.814 89.301-36.893 87.64-85.543-1.499-43.807-37.601-79.207-81.428-79.888z"
          fill="#118e5e"
        />
      </g>
      <g>
        <path
          d="m511.951 230.241c-.396-11.59-3.234-22.581-7.977-32.508-13.886 29.459-44.636 49.418-79.829 47.395-41.219-2.37-74.709-35.384-77.674-76.565-.044-.606-.081-1.21-.111-1.813-.569-11.238-10.451-19.869-21.646-18.724-2.733.279-5.505.426-8.31.432-.077 0-.154 0-.231 0-10.672-.005-19.656 8.098-20.199 18.756-.032.634-.072 1.27-.119 1.908-3.105 42.004-37.872 75.322-79.971 76.613-20.899.641-40.122-6.48-55.016-18.693-7.451-6.109-18.056-6.128-25.473.021-15.141 12.552-34.822 19.82-56.234 18.947-31.433-1.281-58.432-20.388-71.295-47.305-5.224 11.078-8.067 23.498-7.855 36.603.704 43.586 35.76 79.583 79.316 81.358 21.412.873 41.093-6.395 56.234-18.947 7.417-6.149 18.023-6.13 25.473-.021 14.895 12.213 34.117 19.334 55.016 18.693 42.099-1.291 76.865-34.609 79.971-76.613.047-.637.087-1.273.119-1.908.543-10.658 9.528-18.761 20.199-18.756h.23c2.805-.007 5.577-.153 8.31-.432 11.194-1.144 21.077 7.486 21.646 18.724.03.603.068 1.207.111 1.813 2.965 41.181 36.454 74.195 77.674 76.565 48.947 2.815 89.301-36.892 87.641-85.543z"
          fill="#017b4f"
        />
      </g>
      <g>
        <circle cx="139.516" cy="134.701" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="169.417" cy="107.824" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="179.662" cy="179.588" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="206.696" cy="179.588" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="251.458" cy="141.37" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="443.868" cy="202.26" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="55.953" cy="202.26" fill="#017b4f" r="10.245" />
      </g>
      <g>
        <circle cx="98.516" cy="269.192" fill="#118e5e" r="10.245" />
      </g>
    </svg>
  ),
  cabbage: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Cabbage">
        <path
          d="m198.044 72.285c-43.913 74.184 159.7 171.577 210.312 90.77 18.167-29 1.045-52.005-19.176-78.4-30.644-40-68.585-58.348-85.838-59.131-22.915-1.04 0 33.2-51.818 11.46-28.789-12.084-48.172 26.335-53.48 35.301z"
          fill="#80b524"
        ></path>
        <path
          d="m388.15 83.32c-3.74-4.8-7.59-9.29-11.5-13.46q-1.74.495-3.51 1.08c-13.214 4.376-21.607 12.584-31.42 20.674-14.885-17.035-41-30.82-85.17-29.754-11.87.29-19.89-12.57-28.34-24.24a46.715 46.715 0 0 0 -13.04 9.95c-44.388 61.873 78.5 161.67 128.29 113.17q6.525-4.98 13-10c4.068-3.154 28.45-66.82 31.69-67.42z"
          fill="#76a51c"
        ></path>
        <path
          d="m343.456 160.742c-79.826 61.838-168.376 125.258-218.987 44.451-18.169-29.006-40.539-43.793-32.437-76.039 7.172-28.546 52.687-87.672 93.987-99.225 25.818-7.223 34.317 42.494 57.531 41.933 107.329-2.594 108.143 82.499 99.906 88.88z"
          fill="#9ed342"
        ></path>
        <path
          d="m229.14 234.17c-40.87 16.13-78.03 13.56-104.67-28.98-18.17-29-40.54-43.79-32.44-76.04 3.98-15.84 19.77-41.09 40.1-62.41 0-.01 0-.01.02-.02 3.45 4.23 17.69 11.3 22.09 13.32 42.61 19.5-12.3 54.14 52 112.85 15.37 14.03 20.28 27.27 22.9 41.28z"
          fill="#8bc932"
        ></path>
        <path
          d="m253.355 138.227a7.5 7.5 0 0 1 -6.451-3.664c-7.212-12.113-19.063-18.771-31.61-25.821-15.617-8.774-33.318-18.719-43.5-40.678a7.5 7.5 0 1 1 13.609-6.308c8.141 17.563 22.273 25.5 37.235 33.909 13.712 7.7 27.89 15.67 37.152 31.223a7.5 7.5 0 0 1 -6.438 11.339z"
          fill="#b4e055"
        ></path>
        <path
          d="m343.46 160.74c-61.33 47.51-127.8 95.94-178.26 79.21-.38-16.01 5-66.88 3.22-69.81 9.66-18.95 19.97-33.42 35.88-42.33a68.639 68.639 0 0 1 10.4-4.73c30.22-10.88 72.74-7.52 92.26-12.7a79.992 79.992 0 0 0 21.47-9.1 73.266 73.266 0 0 1 17.355 36.908 53.867 53.867 0 0 1 .448 14.85c-.295 2.362-.71 6.101-2.773 7.702z"
          fill="#80b524"
        ></path>
        <path
          d="m260.83 130.29c-5.16.45-10.38 1.02-15.53 1.77a54.923 54.923 0 0 0 -13.84-13.49c6.45-1.28 13.13-2.17 19.78-2.84a60.285 60.285 0 0 1 8.55 11.16 7.36 7.36 0 0 1 1.04 3.4z"
          fill="#9ed342"
        ></path>
        <path
          d="m146.4 244.06c17.96 6.241 123.63 134.527 143.208 135.474 100.858 4.88 178.666-68.36 173.786-163.583-1.752-34.18-17.976-58.617-24.216-91.277-7.384-38.674-30.662-48.81-61.04-38.737-25.166 8.344-32.812 30.573-66.182 39.441-19.514 5.186-62.038 1.823-92.254 12.7-38.102 13.722-47.837 52.228-73.302 105.982z"
          fill="#8bc932"
        ></path>
        <path
          d="m461.11 197.96c-1.77 30.6-7.02 64.83-13.96 96.08-27.52 53.98-86.87 88.91-157.54 85.49-10.56-.51-46.19-38.08-79.57-73.56 32.47-13.25 32.3-19.63 53.1-58.09 27.35-50.58 86.49-6.88 106.93-83.08 6.31-23.56 39.2-46.45 64.84-55.39a86.784 86.784 0 0 1 4.27 15.26c5.09 26.65 16.84 47.83 21.93 73.29z"
          fill="#80b524"
        ></path>
        <path
          d="m353.8 141.77c-.89 3.35-2.76 8.48-4.93 14.42-3.44 9.42-10.6 29.02-9.7 34a74.811 74.811 0 0 0 4.15 13.69c2.04 5.39 4.11 10.88 4.89 17.86a63.065 63.065 0 0 1 -14.69 6.66c.13-7.66-1.86-12.95-4.23-19.22a89.031 89.031 0 0 1 -4.88-16.33c-1.51-8.33 3.35-22.58 10.37-41.81 1.96-5.36 3.8-10.42 4.51-13.11a7.5 7.5 0 0 1 14.51 3.84z"
          fill="#b4e055"
        ></path>
        <path
          d="m288.64 241.67a47.92 47.92 0 0 0 -12.22 9.5c-28.29-22.39-25.48-39.4-22.97-54.59 1.67-10.14 3.12-18.9-4.5-30.7a7.5 7.5 0 0 1 12.61-8.13c10.75 16.66 8.5 30.31 6.69 41.27-2.25 13.63-4.06 24.62 20.39 42.65z"
          fill="#b4e055"
        ></path>
        <path
          d="m348.21 221.74a63.065 63.065 0 0 1 -14.69 6.66 41.565 41.565 0 0 0 -2.92-15.7 59.325 59.325 0 0 0 13.56-6.58 63.049 63.049 0 0 1 4.05 15.62z"
          fill="#8bc932"
        ></path>
        <path
          d="m288.63 241.67a48.505 48.505 0 0 0 -12.21 9.5 102.815 102.815 0 0 1 -9.9-8.85 49.973 49.973 0 0 1 10.12-10.99 90.4 90.4 0 0 0 11.99 10.34z"
          fill="#8bc932"
        ></path>
        <path
          d="m185.17 475.41a230.321 230.321 0 0 0 70.83 11.09c127.3 0 230.5-103.2 230.5-230.5 0-45.694-22.7-75.3-15.147-123.809 4.96-31.836-85.362 6.885-96.285 47.613-20.436 76.2-79.581 32.5-106.927 83.08-21.437 39.651-20.6 45.192-56.2 59.334-43.672 17.352-63.771 37.952-26.771 153.192z"
          fill="#9ed342"
        ></path>
        <path
          d="m317.314 474.148a7.5 7.5 0 0 1 -6.333-11.509c3.983-6.3 7.5-13.594 11.232-21.317 8.558-17.728 17.407-36.06 33.821-46.843 36.957-24.278 55.342-62.643 64.256-90.552a230.373 230.373 0 0 0 10.679-56.138c.659-54.86 3.706-64.82 11.064-88.866.758-2.477 1.564-5.109 2.419-7.967a7.5 7.5 0 1 1 14.369 4.3c-.864 2.889-1.678 5.55-2.444 8.054-7.116 23.256-9.779 31.959-10.411 84.737v.125c-.031 1.1-.889 27.248-11.247 59.884-13.819 43.541-38.179 77.76-70.446 98.958-12.947 8.5-20.878 24.936-28.549 40.827-3.747 7.762-7.621 15.788-12.061 22.812a7.5 7.5 0 0 1 -6.349 3.495z"
          fill="#f1e8dc"
        ></path>
        <path
          d="m438.62 228.552a7.481 7.481 0 0 1 -5.745-2.674c-15.86-18.869-27.011-42.958-33.142-71.6a7.5 7.5 0 1 1 14.668-3.14c5.613 26.217 15.692 48.115 29.956 65.087a7.5 7.5 0 0 1 -5.737 12.325z"
          fill="#f1e8dc"
        ></path>
        <path
          d="m486.5 256q0 7.53-.48 14.95c-14 22.13-33.08 37.02-57.02 44.45a7.5 7.5 0 1 1 -4.45-14.32c28.49-8.84 48.46-29.42 60.84-62.78a143.591 143.591 0 0 1 1.11 17.7z"
          fill="#f1e8dc"
        ></path>
        <path
          d="m350.11 421.52c-5.49 7.88-9.98 17.19-14.39 26.32-1.14 2.35-2.29 4.73-3.46 7.1 2.9-14.12 3.5-26.38 2.32-37.13a84.021 84.021 0 0 1 12.75-16.3 88.48 88.48 0 0 1 2.78 20.01z"
          fill="#f1ddc8"
        ></path>
        <path
          d="m374.572 392.468a7.5 7.5 0 0 1 -7.372-6.168c-7.154-39.488-32.752-71.61-76.082-95.473a7.5 7.5 0 0 1 7.236-13.14c47.478 26.149 75.607 61.791 83.606 105.938a7.51 7.51 0 0 1 -7.389 8.839z"
          fill="#f1e8dc"
        ></path>
        <path
          d="m342.34 469.78a.938.938 0 0 1 -.15.06c-.15.06-.29.12-.44.18-.41.17-.82.33-1.23.49a231.537 231.537 0 0 1 -155.35 4.9c-37-115.24-16.9-135.84 26.77-153.19 19.68-7.82 28.22-13.01 35.55-22.78 1.99 3.31 4.25 6.71 6.82 10.2 27.69 37.69 123.61 46.45 88.03 160.14z"
          fill="#8bc932"
        ></path>
        <path
          d="m247.49 299.44a46.714 46.714 0 0 1 -10.78 10.54c-5.61-8.17-16.94-9.58-30.34-7.91-27.11-28.81-52.06-55.26-59.97-58.01 10.17-21.48 17.84-40.53 25.81-56.53 2.67-3.15 3.94-5.35 3.17-6.16a.467.467 0 0 1 .05-.1c.64-1.19 1.27-2.35 1.91-3.5 2.13-3.8 4.31-7.39 6.61-10.75 5.06 8.05 12.21 16.67 22.29 25.87 15.37 14.03 20.28 27.27 22.9 41.28 3.55 19.03 2.85 39.48 18.35 65.27z"
          fill="#80b524"
        ></path>
        <path
          d="m326.83 475.41a230.321 230.321 0 0 1 -70.83 11.09c-127.3 0-230.5-103.2-230.5-230.5 0-45.694 12.915-91.518 28.69-131.022 16.594-41.555 22.64-64.64 35.61-68.207 17.359-4.771 32.852 21.688 32.852 21.688 71.835 18.175-2.362 53.646 68.591 118.429 38.916 35.533 10.782 66 48.067 116.752 27.822 37.874 124.52 46.53 87.52 161.77z"
          fill="#b4e055"
        ></path>
        <path
          d="m275.99 485.64q-9.885.855-19.99.86c-127.3 0-230.5-103.2-230.5-230.5 0-45.69 12.91-91.52 28.69-131.02 16.59-41.56 22.64-64.64 35.61-68.21 10.71-2.94 20.72 6.01 26.8 13.29-6.19 11.38-12.37 29.77-22.41 54.92-15.78 39.5-28.69 85.33-28.69 131.02 0 120.56 92.56 219.5 210.49 229.64z"
          fill="#9ed342"
        ></path>
        <g fill="#f1e8dc">
          <path d="m241.38 486.04a1.087 1.087 0 0 1 -.18-.01 228.128 228.128 0 0 1 -25.69-3.08l-35.03-31.5a6.987 6.987 0 0 1 -1.06-1.18l-33.88-46.79-60.87-69.97a7.41 7.41 0 0 1 -1.76-3.8l-16.41-108.84a7.293 7.293 0 0 1 -.07-1.55l8.56-146.13a54.542 54.542 0 0 1 6.15-10.14c.15-.19.3-.38.46-.56.28-.34.57-.67.86-.98h.01a4.21 4.21 0 0 1 .71-.01 7.5 7.5 0 0 1 7.05 7.93l-8.78 149.98 15.97 105.9 59.66 68.58c.14.16.28.34.41.52l33.61 46.42z"></path>
          <path d="m73.916 227.254a7.5 7.5 0 0 1 -5.35-12.757q2.346-2.387 4.632-4.7c26.038-26.389 44.852-45.456 49.618-82.82a7.5 7.5 0 1 1 14.879 1.9c-5.408 42.392-26.772 64.044-53.82 91.457q-2.274 2.305-4.609 4.678a7.479 7.479 0 0 1 -5.35 2.242z"></path>
          <path d="m96.77 332.42a7.493 7.493 0 0 1 -10.27 2.62c-28.76-17.07-49.2-43.12-60.99-77.61-.01-.47-.01-.95-.01-1.43a265.147 265.147 0 0 1 1.81-30.46 7.492 7.492 0 0 1 6.57 5.89c8.94 41.76 29.22 72.28 60.27 90.71a7.5 7.5 0 0 1 2.62 10.28z"></path>
          <path d="m188.907 446.758a7.5 7.5 0 0 1 -5.173-12.932c29.567-28.147 36.471-63.867 21.106-109.2a7.5 7.5 0 0 1 14.207-4.814c17.191 50.724 8.79 92.74-24.969 124.879a7.477 7.477 0 0 1 -5.171 2.067z"></path>
          <path d="m153.04 406.13a168.814 168.814 0 0 1 -36.48 4.25 120.282 120.282 0 0 1 -36.41-5.35 231.923 231.923 0 0 1 -17.98-24.23 7.335 7.335 0 0 1 2.72.99c22.82 13.86 51.39 17.13 84.9 9.7a7.5 7.5 0 1 1 3.25 14.64z"></path>
        </g>
        <path
          d="m90.23 69.43-4.6 78.531c-.132 2.243-1.427 4.365-2.148 6.453-.91 2.633-1.738 5.306-2.57 7.967a327.363 327.363 0 0 0 -11.885 50.793q-1.005 6.361-1.779 12.755c-.992-3.968-.754-8.126-.51-12.209q1.632-27.254 3.213-54.511l2.883-49.219q.968-16.507 1.934-33.016c.074-1.257.222-2.534.222-3.794a48.564 48.564 0 0 1 7.48-11.67 4.21 4.21 0 0 1 .71-.01 7.5 7.5 0 0 1 7.05 7.93z"
          fill="#f1ddc8"
        ></path>
        <path
          d="m77.28 328.96c-.03-.01-.04 0-.02.02-15.79-10.89-28.84-25.7-38.48-42.23a155.891 155.891 0 0 1 -7.31-14.2c-1.1-2.44-2.14-4.92-3.13-7.41-.85-2.15-2.78-5.4-2.83-7.71-.01-.01-.01-.01 0-.02 0-.48.28-1.04-.01-1.41a265.147 265.147 0 0 1 1.81-30.46 7.492 7.492 0 0 1 6.57 5.89c6.42 29.97 18.67 54.14 36.55 72.22.01.03.01.05.02.08a230.838 230.838 0 0 0 6.83 25.23z"
          fill="#f1ddc8"
        ></path>
        <path
          d="m124.63 410.15q-4.08.225-8.07.23a120.282 120.282 0 0 1 -36.41-5.35 230.423 230.423 0 0 1 -17.97-24.23 7.289 7.289 0 0 1 2.71.99c13.77 8.37 29.64 12.87 47.43 13.49h.01q1.455 1.92 2.96 3.82c.87 1.09 1.74 2.18 2.63 3.26.25.3.5.6.76.91q1.29 1.56 2.61 3.09c.05.06.1.12.15.17q1.455 1.7 2.95 3.35a2.911 2.911 0 0 0 .24.27z"
          fill="#f1ddc8"
        ></path>
        <path
          d="m241.38 486.04a228.652 228.652 0 0 1 -25.85-3.08c-.01 0-.02 0-.02-.01l-23.65-21.27a228.4 228.4 0 0 0 39.96 15.76z"
          fill="#f1ddc8"
        ></path>
      </g>
    </svg>
  ),
  pumpkin: (props) => (
    <svg height="512" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Layer_11">
        <path
          d="m14.584 4.664c.954-1.879 3.077-2.921 5.153-2.61 2.247.336 4.274 2.858 2.71 5.06-.426.599-1.374 1.217-2.153.897-.308-.126-.654-.244-.603-.665.086-.711.811-.287 1.161-.536 1.739-1.235-1.082-3.173-2.637-2.246-3.858 2.298 2.241 10.331-1.923 11.834-2.729.985-2.783-2.217-2.712-3.92.105-2.524-.178-5.487 1.004-7.814z"
          fill="#7dd54d"
        ></path>
        <path
          d="m8.344 29.093c3.227 0 5.843-2.616 5.843-5.843v-5.105c0-3.227-2.616-5.843-5.843-5.843-3.227 0-5.843 2.616-5.843 5.843v5.105c0 3.227 2.616 5.843 5.843 5.843z"
          fill="#fe9a2b"
        ></path>
        <path
          d="m2.506 18.15v5.1c0 3.23 2.61 5.84 5.84 5.84 3.22 0 5.84-2.61 5.84-5.84v-1.62c0 2.75-2.23 4.98-4.98 4.98s-4.97-2.23-4.97-4.98v-4.35c0-1.38.55-2.62 1.45-3.52.81-.81 1.9-1.35 3.12-1.44-.15-.01-.31-.02-.46-.02-1.62 0-3.08.66-4.13 1.71-1.06 1.06-1.71 2.53-1.71 4.14z"
          fill="#ff881d"
        ></path>
        <path
          d="m23.656 29.093c-3.227 0-5.843-2.616-5.843-5.843v-5.105c0-3.227 2.616-5.843 5.843-5.843 3.227 0 5.843 2.616 5.843 5.843v5.105c0 3.227-2.616 5.843-5.843 5.843z"
          fill="#fe9a2b"
        ></path>
        <path
          d="m29.494 18.15v5.1c0 3.23-2.61 5.84-5.84 5.84-3.22 0-5.84-2.61-5.84-5.84v-1.62c0 2.75 2.23 4.98 4.98 4.98s4.97-2.23 4.97-4.98v-4.35c0-1.38-.55-2.62-1.45-3.52-.81-.81-1.9-1.35-3.12-1.44.15-.01.31-.02.46-.02 1.62 0 3.08.66 4.13 1.71 1.06 1.06 1.71 2.53 1.71 4.14z"
          fill="#ff881d"
        ></path>
        <path
          d="m17.125 30h-2.254c-2.953 0-5.347-2.394-5.347-5.347v-7.91c0-2.953 2.394-5.347 5.347-5.347h2.254c2.953 0 5.347 2.394 5.347 5.347v7.91c0 2.953-2.394 5.347-5.347 5.347z"
          fill="#fe9a2b"
        ></path>
        <path
          d="m22.476 16.738v7.919c0 2.948-2.395 5.343-5.352 5.343h-2.252c-2.462 0-4.541-1.66-5.162-3.931.859.992 2.128 1.622 3.54 1.622h1.975c2.595 0 4.685-2.099 4.685-4.684v-6.927c0-2.586-2.089-4.684-4.685-4.684h1.899c2.957-.001 5.352 2.394 5.352 5.342z"
          fill="#ff881d"
        ></path>
        <g fill="#ffa95c">
          <path d="m13.7 13.863c-.132-.227-.423-.302-.649-.173-1.155.67-1.873 1.913-1.873 3.244v1.468c0 .262.212.475.475.475s.475-.213.475-.475v-1.468c0-.994.537-1.922 1.4-2.422.226-.132.304-.422.172-.649z"></path>
          <path d="m11.652 20.014c-.263 0-.475.213-.475.475v1.11c0 .262.212.475.475.475s.475-.213.475-.475v-1.11c0-.262-.212-.475-.475-.475z"></path>
        </g>
      </g>
    </svg>
  ),
  zuccini: (props) => (
    <svg
      id="fi_5194816"
      height="512"
      viewBox="0 0 450 450"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g clipRule="evenodd" fillRule="evenodd">
          <path
            d="m290.628 297.263c4.751 14.468 9.933 24.617 26.129 33.902 0-9.285-1.512-16.843-1.512-26.129 6.046 7.558 17.059 16.411 23.105 23.753 1.728-4.103.216-10.797 1.943-14.9 5.614 4.103 10.797 7.774 16.195 12.093 0-3.023.216-6.046.216-9.069 12.093-1.296 19.219 0 31.527-1.08-7.126-3.455-12.524-7.126-15.979-11.661 3.671-2.807 7.126-6.046 11.013-8.854-9.717-.864-19.434-1.08-29.152-1.943 2.807-2.159 6.046-4.535 8.853-6.694-14.036-.864-23.105 0-32.607-8.206 1.943-8.638 21.162-1.512 31.959.216 0-1.728 3.455-2.591 3.455-4.319 8.853 1.728 16.627-1.512 25.481.216-3.455-6.91-7.99-9.933-11.229-16.843 7.774-3.023 17.275-3.023 25.265-6.046-1.296-3.671-5.614-9.933-6.91-13.388 6.694-3.671 16.411-10.797 23.105-14.468-14.252-6.046-21.594-4.967-29.368-2.159-1.726-15.332-101.489 1.08-101.489 75.579z"
            fill="#83b03a"
          ></path>
          <path
            d="m226.494 143.73c8.422 1.296 16.627 2.375 25.049 3.671-30.016-55.496 8.422-7.774 8.422-15.764 0-21.81-9.069-31.527 7.774-20.946 19.003-33.686 21.378-46.427 19.003.216 20.298-11.661 13.172.432 3.887 23.753 8.206-2.159 13.604-1.943 21.81-3.887-3.023 5.83-17.059 42.108-17.275 42.108-35.416 5.399-43.189-10.58-68.67-29.151z"
            fill="#96c745"
          ></path>
          <path
            d="m218.72 159.062c83.784 8.422 102.139-17.059 134.53-8.422-10.797 38.653-68.237 95.445-98.684 118.766 9.933-1.512-139.928 22.674-177.502.432-37.357-22.026-58.951-73.635-28.504-104.73 40.813-41.676 119.63-14.468 170.16-6.046z"
            fill="#b1cf75"
          ></path>
          <path
            d="m75.337 266.383c-26.129-15.332-42.756-41.676-41.028-68.884 61.327 2.375 153.101-12.74 236.453-29.8-38.222 61.759-110.777 148.782-195.425 98.684z"
            fill="#aac96d"
          ></path>
          <path
            d="m350.011 151.072c38.437 11.877 55.928 60.247 19.435 87.239-14.252 10.581-61.759 22.674-117.903 31.095 30.879-23.753 88.966-79.681 98.468-118.334z"
            fill="#aac96d"
          ></path>
          <path
            d="m372.252 162.949c15.332 17.491 20.298 35.63 14.252 52.905 17.707-5.398 14.468-7.126 22.674-23.753 20.946-42.756-28.072-36.494-36.926-29.152z"
            fill="#7a993d"
          ></path>
          <path
            d="m389.959 202.034c13.388-7.126 16.843-8.638 19.866-13.172 2.591-6.046 5.83-13.82 3.455-20.514-12.309 2.591-17.491 3.023-29.584 10.149 3.456 6.909 5.616 12.308 6.263 23.537z"
            fill="#698731"
          ></path>
          <path
            d="m313.733 145.89c-27.64 1.512-50.314 21.594-87.239 41.244-27.424 10.581-100.412 9.717-139.712 48.802-26.345 26.129-43.62 84 4.967 119.63 68.669 50.314 230.623-53.553 267.332-149.214 13.387-34.766-14.253-62.406-45.348-60.462z"
            fill="#cee89d"
          ></path>
          <path
            d="m75.121 339.587c5.398 7.126 12.524 13.388 21.594 19.219 71.908 45.347 225.656-61.111 262.366-156.772 7.558-19.434 2.807-31.527-9.717-41.46-33.903 98.683-170.377 183.763-274.243 179.013z"
            fill="#bdd987"
          ></path>
          <path
            d="m81.383 295.319c6.046-1.943 13.388 4.319 16.411 14.036s.432 19.219-5.614 21.378c-6.046 1.943-13.604-4.319-16.411-14.036-3.024-9.717-.432-19.218 5.614-21.378z"
            fill="#cfbf78"
          ></path>
          <path
            d="m323.666 146.105c15.332-7.126 14.684-13.82 29.584-7.126 20.082 6.694 14.684 30.663 9.717 46.859 0-21.162-18.355-35.846-39.301-39.733z"
            fill="#8ead4f"
          ></path>
          <path
            d="m353.25 138.979c20.514 7.126 15.116 25.049 9.285 46.211 0-11.013-4.535-18.355-12.524-26.129z"
            fill="#79983a"
          ></path>
          <path
            d="m37.115 184.327c4.319.432 7.342 7.126 6.91 14.9-.432 7.99-4.319 14.036-8.422 13.604-4.319-.432-7.342-7.126-6.91-14.9.433-7.99 4.32-14.036 8.422-13.604z"
            fill="#cfbf78"
          ></path>
          <path
            d="m44.025 197.715c0 4.751-2.375 15.764-8.422 15.116-6.046-.432-7.342-11.013-6.91-15.548 4.967.216 9.934.432 15.332.432z"
            fill="#b6a55b"
          ></path>
          <path
            d="m104.272 238.959c14.036-9.285 29.584-11.877 34.55-5.614 4.967 6.046-2.159 18.787-16.195 28.072s-29.584 11.877-34.55 5.83c-4.967-6.262 2.159-18.786 16.195-28.288z"
            fill="#e0f5b9"
          ></path>
        </g>
        <path
          d="m382.618 175.473c9.501-5.183 15.548-6.478 24.833-8.422.648-.216-3.023-2.807-3.239-3.023-7.342-4.319-22.242-2.591-29.584.864 3.239 3.239 5.83 6.694 7.99 10.581zm-14.252-16.195c.648.648 1.512 1.08 2.159 1.728 9.069-4.967 26.56-7.126 36.062-1.728 13.172 6.694 8.206 23.321 3.239 33.471-5.614 11.445-4.967 18.571-18.355 23.321.648.864 1.08 1.727 1.728 2.591 10.365-2.807 20.298-1.08 30.231 3.239 1.943.864 2.159 3.671.216 4.751-7.774 4.103-15.332 8.638-22.889 12.956 1.943 3.023 5.183 6.478 6.478 9.933.648 1.296-.216 2.807-1.512 3.455-7.558 2.807-15.979 3.887-23.753 6.478 3.671 5.398 8.853 8.853 11.661 15.116 1.08 1.943-.432 4.319-2.807 3.887-8.422-1.727-17.707-.864-26.345-1.943 0 2.159.648 4.319-3.239 4.751-2.159-.432-4.751-1.08-7.558-1.728-8.206-1.727-18.139-3.887-21.162-1.727 7.126 5.183 14.684 5.614 24.833 6.262l4.535.216c2.375 0 3.455 3.239 1.512 4.751l-3.023 2.375 21.378 1.943c2.591.216 3.671 3.455 1.512 4.967l-8.854 6.262c3.887 3.671 9.501 6.694 14.468 9.069 2.375 1.08 1.728 4.751-1.08 4.967-9.933 1.08-19.866.432-29.8 1.08v6.478c0 2.375-2.375 3.671-4.319 2.159l-12.524-9.717v2.591c0 3.023 0 5.83-1.296 8.422-.648 1.943-3.239 2.159-4.535.648-5.398-6.694-13.388-12.956-19.65-19.003 1.296 6.91 3.455 13.388 3.455 20.514 0 1.943-2.159 3.239-4.103 2.159-13.604-7.774-22.674-18.571-28.288-33.255-42.972 37.357-124.813 87.023-181.605 65.214-41.892-15.979-57.872-61.327-40.812-101.275-7.99-6.262-14.684-13.604-20.082-21.81-5.83-8.638-9.933-17.923-12.093-27.424-2.159-.864-3.887-3.023-5.183-5.614-3.023-6.694-2.591-16.627 1.512-22.674 1.512-2.159 3.239-3.887 5.398-4.319 2.591-6.91 6.478-13.172 11.661-18.355 34.766-35.414 95.445-23.105 143.599-13.388 17.491 3.455 31.311 5.83 49.018 6.478-4.535-3.887-9.285-7.774-14.684-11.877-2.375-1.728-.864-5.183 1.943-4.751l19.435 3.023c-8.854-17.275-9.717-24.185-6.694-25.697 4.319-2.375 14.468 7.558 18.571 10.365-.432-5.614-1.08-10.365-1.728-13.82-1.943-9.933-.432-14.252 10.581-7.99 3.239-5.614 14.036-28.288 19.003-28.072 3.887.216 4.535 8.638 3.455 28.288 20.082-9.285 9.933 12.74 6.262 21.378l-1.728 4.103 18.787-4.967c2.159-.432 4.103 1.943 3.023 3.887-.432 1.08-1.512 3.239-2.807 6.046l-3.239 7.558c3.887-.432 7.558-.432 11.445 0 3.239-1.08 14.684-13.604 28.72-9.933 11.229 3.025 18.787 11.878 19.867 24.187zm16.843 20.946c2.591 5.398 4.319 11.661 4.967 17.707 4.319-2.375 13.388-6.046 15.764-9.717 2.159-4.751 4.319-10.797 3.671-16.195-9.502 1.943-15.765 3.454-24.402 8.205zm1.727 38.653c-9.933 23.537-33.902 30.016-56.36 36.062-11.229 14.468-24.617 28.72-39.301 41.892 4.103 12.524 11.013 22.242 22.026 29.8-1.08-7.558-3.887-15.332-3.887-22.89 0-2.591 3.455-3.671 4.967-1.512 5.83 7.126 14.468 13.604 21.378 20.514 0-3.239-.216-6.91 1.08-9.933.648-1.512 2.807-2.159 4.103-1.08l11.661 9.069v-3.455c0-1.512 1.296-2.807 2.807-2.807 7.558-.648 14.9-.432 22.674-.648-3.455-2.159-7.342-4.751-9.717-7.99-1.08-1.296-.864-2.807.216-3.887l5.614-3.887-21.162-1.943c-2.375-.216-3.239-3.239-1.296-4.751l2.591-2.159c-9.501-.648-17.059-1.512-24.617-6.91-4.319-3.023-4.319-6.694.864-9.285 6.478-3.239 18.787 0 24.185 1.296l4.319.864v-1.728c0-1.728 1.512-3.023 3.239-2.591 7.558 1.296 15.979.864 23.753 1.512-3.671-4.535-7.99-7.99-10.581-13.388-.648-1.296 0-3.023 1.296-3.671 7.126-3.023 16.411-4.103 24.185-6.478-2.159-3.023-5.183-6.262-6.478-9.501-.432-1.296.216-2.807 1.512-3.455 6.694-3.455 13.388-7.342 19.866-11.229-8.206-2.591-15.332-2.807-23.537 0-1.512.432-3.023-.216-3.455-1.728-.649-1.944-.649-2.16-1.945-4.103zm-51.177 29.152c24.833-7.342 52.473-18.787 49.018-50.53-1.296-11.661-9.069-22.889-16.411-31.311 0 0 .216 8.854-4.751 23.969-1.296 17.923-17.491 43.62-27.856 57.872zm-297.996-32.823c1.943 8.422 5.83 16.843 10.797 24.617 4.967 7.342 11.013 14.036 17.923 19.866 4.319-8.638 9.933-16.627 16.843-23.105 28.504-27.424 74.067-36.494 107.969-43.188 30.231-6.046 35.414-8.854 61.758-24.617 3.455-2.159 6.91-4.319 10.149-6.262-26.56 1.728-49.018-1.08-74.931-6.262-47.075-9.501-106.242-21.378-138.849 12.093-4.319 4.319-7.774 9.285-10.149 15.116 1.943 1.08 3.239 2.807 4.319 5.183 3.023 6.478 2.591 16.411-1.296 22.674-1.294 1.726-2.805 3.237-4.533 3.885zm208.813-57.44c9.285 0 18.571-.432 27.856-1.512 9.285-4.967 18.139-8.638 27.64-10.365l5.183-11.661-18.571 4.751c-1.943.648-3.887-1.512-3.023-3.455 3.455-8.853 18.355-33.255.864-21.594-1.943 1.08-4.103-.432-4.103-2.591 1.08-19.219 1.943-27.208 1.728-27.208 0 0-13.388 24.401-15.116 27.856-.864 1.296-2.591 1.728-3.887.864-.432-.216-5.83-4.319-5.83-4.319s.216 2.159.864 5.183c.864 4.535 5.183 21.594-1.512 21.594-4.103 0-17.491-12.524-17.923-12.308-.648.216 1.943 5.83 11.229 22.889 1.296 1.943-.432 4.319-2.591 4.103l-14.468-2.159c4.102 3.238 7.773 6.477 11.66 9.932zm41.028 135.178c26.992-24.401 54.633-56.576 67.805-90.694 4.319-11.661 3.671-21.162-3.239-31.743-5.83-8.638-14.9-15.332-24.617-18.787-5.398-1.296-11.013-1.943-16.843-1.512-18.355 1.08-34.55 10.797-54.848 23.105-30.447 18.355-28.504 18.355-63.486 25.265-33.255 6.694-78.17 15.548-105.378 41.892-37.142 35.847-31.528 100.628 20.082 120.495 56.36 21.594 139.928-31.311 180.524-68.021zm40.813-146.407c6.046 1.512 12.524 4.319 17.491 7.774l1.943-13.82c-9.069-3.455-19.65 5.83-19.434 6.046zm22.457 11.877c4.751 4.535 8.638 9.933 10.797 16.195 1.728-11.229 2.375-24.833-8.638-31.743zm-312.031 32.391c-1.728-3.455-3.671-4.103-5.83-.648-3.023 4.319-3.455 12.524-1.08 17.275 1.512 3.455 3.455 4.319 5.83.864 2.807-4.535 3.239-12.525 1.08-17.491zm54.632 103.65c7.342 6.046 11.013 18.139 8.422 27.424-2.591 9.717-11.445 13.172-19.434 6.694-7.342-6.046-11.013-18.355-8.638-27.424 2.591-9.717 11.661-13.172 19.65-6.694zm-14.252 7.99c-1.943 7.126.864 17.275 6.694 21.81 4.967 4.103 9.285 2.159 10.797-3.887 1.943-6.91-.864-17.059-6.694-21.81-4.966-4.103-9.285-1.943-10.797 3.887zm311.168-98.684c0 2.375-.432 4.967-.864 7.342 8.206-3.023 11.013-8.206 11.877-12.956-3.671 1.943-7.342 3.671-11.013 5.614z"
          fill="#1a1a1a"
        ></path>
      </g>
    </svg>
  ),
  potato: (props) => (
    <svg viewBox="0 -32 511.99993 511" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m246.316406.503906c-54.417968-.402344-101.664062 30.496094-124.800781 75.761719-19.933594 39.011719-43.796875 75.929687-72.96875 108.613281-24.425781 27.363282-47.527344 67.886719-48.4960938 123.734375-.0351562 1.210938-.0507812 2.421875-.0507812 3.636719 0 75.070312 60.859375 135.929688 135.929688 135.929688.144531 0 .285156-.003907.429687-.003907 1.027344-.003906 2.054687-.015625 3.078125-.039062 135.46875-1.878907 244.710938-112.261719 244.710938-248.175781v-58.832032c0-76.582031-61.253907-140.058594-137.832032-140.625zm0 0"
        fill="#f0a65f"
      />
      <path
        d="m384.148438 199.960938v-58.832032c0-46.863281-22.941407-88.816406-58.292969-114.449218v-.003907c16.984375 23.386719 27 52.199219 27 83.15625v14.285157c0 25.1875-18.144531 46.675781-42.953125 51.011718-12.953125 2.265625-25.652344 3.742188-38.234375 4.457032-40.820313 2.316406-77.90625 18.507812-107.257813 46.828124-.785156.746094-1.5625 1.503907-2.332031 2.273438-23.757813 23.753906-36.839844 55.339844-36.839844 88.9375 0 19.675781 5.597657 37.507812 12.597657 52.113281 10.402343 21.710938-5.027344 47.03125-29.101563 47.101563-.195313 0-.394531 0-.589844 0-36.859375 0-60.398437-9.386719-82.699219-25.398438 24.667969 34.355469 64.960938 56.738282 110.484376 56.738282 135.253906-.660157 248.21875-112.472657 248.21875-248.21875zm0 0"
        fill="#e28540"
      />
      <path
        d="m312.195312 202.910156c-3.207031 0-6.207031-1.992187-7.347656-5.175781-.277344-.75-6.101562-15.949219-24.363281-22.320313-4.070313-1.421874-6.214844-5.871093-4.796875-9.941406 1.417969-4.066406 5.871094-6.222656 9.941406-4.796875 25.625 8.9375 33.601563 30.90625 33.929688 31.839844 1.429687 4.066406-.710938 8.519531-4.777344 9.949219-.855469.300781-1.726562.445312-2.585938.445312zm0 0"
        fill="#e28540"
      />
      <path
        d="m481.511719 207.679688c-29.496094-29.9375-72.164063-38.859376-109.515625-26.777344-32.183594 10.414062-65.371094 17.546875-99.144532 19.460937-28.28125 1.609375-63.023437 11.117188-94.042968 41.082031-.679688.644532-1.347656 1.296876-2.011719 1.960938-40.992187 40.992188-40.992187 107.449219 0 148.441406.078125.078125.15625.152344.234375.230469.566406.5625 1.128906 1.117187 1.703125 1.660156 74.996094 72.941407 194.914063 72.320313 269.125-1.890625l32.125-32.125c41.816406-41.816406 43.027344-109.917968 1.527344-152.042968zm0 0"
        fill="#f0a65f"
      />
      <g fill="#e28540">
        <path d="m481.511719 207.679688c-4.5-4.566407-9.308594-8.636719-14.351563-12.222657 29.882813 42.132813 25.199219 101.21875-12.511718 138.929688l-32.125 32.125c-69.949219 69.949219-180.496094 74.507812-255.765626 13.722656 3.015626 4.710937 11.402344 12.960937 11.976563 13.503906 74.996094 72.941407 194.914063 72.320313 269.125-1.890625l32.125-32.125c41.816406-41.816406 43.027344-109.917968 1.527344-152.042968zm0 0" />
        <path d="m153.53125 43.667969c.167969-.011719 16.941406-1.128907 33.238281 4.710937.871094.3125 1.757813.457032 2.632813.457032 3.203125 0 6.207031-1.984376 7.347656-5.171876 1.453125-4.058593-.65625-8.527343-4.714844-9.980468-11.089844-3.976563-22.199218-5.25-29.824218-5.601563-5.324219 3.980469-10.351563 8.324219-15.046876 13.007813 1.558594 1.738281 3.863282 2.769531 6.367188 2.578125zm0 0" />
        <path d="m199.8125 173.769531c-2.46875 0-4.894531-1.167969-6.414062-3.34375-10.925782-15.695312-35.074219-16.429687-35.316407-16.429687-4.308593-.054688-7.761719-3.589844-7.707031-7.902344.050781-4.277344 3.535156-7.707031 7.800781-7.707031h.097657c1.3125.015625 32.292968.652343 47.9375 23.117187 2.460937 3.539063 1.589843 8.402344-1.945313 10.863282-1.359375.949218-2.914063 1.402343-4.453125 1.402343zm0 0" />
        <path d="m306.984375 100.925781c-3.515625 0-6.710937-2.398437-7.578125-5.96875-4.28125-17.667969-24.363281-22.113281-25.214844-22.296875-4.207031-.886718-6.914062-5.011718-6.042968-9.222656.871093-4.207031 4.964843-6.917969 9.175781-6.066406 1.246093.25 30.609375 6.503906 37.253906 33.90625 1.015625 4.191406-1.558594 8.410156-5.746094 9.425781-.617187.148437-1.238281.222656-1.847656.222656zm0 0" />
        <path d="m105.101562 265.347656c-3.445312 0-6.59375-2.292968-7.53125-5.777344-5.804687-21.5625-33.761718-25.46875-34.042968-25.507812-4.261719-.558594-7.285156-4.464844-6.738282-8.730469.550782-4.265625 4.4375-7.285156 8.699219-6.753906 1.574219.195313 38.605469 5.179687 47.15625 36.933594 1.117188 4.164062-1.347656 8.445312-5.507812 9.566406-.683594.183594-1.363281.269531-2.035157.269531zm0 0" />
        <path d="m398.496094 175.90625c-7.078125.4375-14.121094 1.570312-21.019532 3.402344.585938 2.332031 2.230469 4.363281 4.628907 5.335937.246093.101563 24.671875 10.246094 27.449219 32.25.5 3.945313 3.859374 6.828125 7.734374 6.828125.328126 0 .65625-.019531.988282-.0625 4.277344-.542968 7.304687-4.445312 6.765625-8.722656-2.507813-19.867188-16.480469-32.425781-26.546875-39.03125zm0 0" />
        <path d="m342.363281 279.914062c-4.015625 0-7.429687-3.082031-7.765625-7.15625-1.664062-19.96875-25.355468-30.878906-25.589844-30.988281-3.921874-1.769531-5.683593-6.382812-3.925781-10.308593 1.757813-3.925782 6.351563-5.695313 10.285157-3.945313 1.320312.585937 32.347656 14.699219 34.785156 43.945313.359375 4.296874-2.832032 8.070312-7.128906 8.425781-.222657.019531-.441407.027343-.660157.027343zm0 0" />
        <path d="m423.535156 302.8125c-3.910156 0-7.285156-2.933594-7.746094-6.914062-1.570312-13.636719-14.601562-21.035157-14.730468-21.109376-3.753906-2.085937-5.132813-6.824218-3.066406-10.585937 2.066406-3.761719 6.761718-5.164063 10.535156-3.117187.828125.445312 20.253906 11.203124 22.769531 33.023437.492187 4.28125-2.578125 8.152344-6.859375 8.648437-.300781.035157-.605469.054688-.902344.054688zm0 0" />
        <path d="m201.878906 276.792969c-4.132812 0-7.578125-3.242188-7.789062-7.414063-.726563-14.566406-18.632813-18.28125-18.816406-18.320312-4.226563-.835938-6.972657-4.945313-6.136719-9.171875.839843-4.230469 4.949219-6.976563 9.175781-6.136719 10.382812 2.058594 30.304688 11.574219 31.367188 32.847656.214843 4.304688-3.101563 7.972656-7.40625 8.183594-.128907.007812-.261719.011719-.394532.011719zm0 0" />
        <path d="m336.324219 396.84375c-1.226563-4.132812-5.570313-6.484375-9.703125-5.253906-4.132813 1.226562-6.484375 5.574218-5.257813 9.703125 6.808594 22.890625-6.324219 39.992187-6.945312 40.777343-1.378907 1.730469-1.898438 3.867188-1.628907 5.902344 5.660157-.015625 11.320313-.28125 16.960938-.792968 5.003906-8.347657 13.484375-27.113282 6.574219-50.335938zm0 0" />
      </g>
    </svg>
  ),
  mushroom: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m464.53 352.53a78.488 78.488 0 0 1 -55.75 23.2 79.669 79.669 0 0 1 -45.75-14.49.014.014 0 0 1 -.02 0 81.58 81.58 0 0 1 -11.01-9.24l-192-192c-31.29-31.29-31.82-81.24-.53-112.53a80.124 80.124 0 0 1 63.91-23.14l107.41 9.76a162.5 162.5 0 0 1 146.35 140.32c.3 2.26.56 4.52.77 6.8l9.76 107.41a80.124 80.124 0 0 1 -23.14 63.91z"
        fill="#92563a"
      />
      <path
        d="m464.53 352.53a78.488 78.488 0 0 1 -55.75 23.2 79.669 79.669 0 0 1 -45.75-14.49.014.014 0 0 1 -.02 0 81.58 81.58 0 0 1 -11.01-9.24l-151.61-151.61c86 16.61 181.82 13.67 276.75-25.98.3 2.26.56 4.52.77 6.8l9.76 107.41a80.124 80.124 0 0 1 -23.14 63.91z"
        fill="#875036"
      />
      <path
        d="m288 288-18.43 22.11-39.11 46.94a212.392 212.392 0 0 0 -35.05 59.69l-6.78 17.62a83.691 83.691 0 0 1 -78.1 53.64h-2.85a83.683 83.683 0 0 1 -26.46-163.07 212.232 212.232 0 0 0 69.98-39.33l50.84-43.02 21.96-18.58z"
        fill="#f2dec2"
      />
      <path d="m288 288-18.43 22.11-67.53-67.53 21.96-18.58z" fill="#e5d2b8" />
      <path
        d="m161.479 328h85.041v15.999h-85.041z"
        fill="#d9c7ae"
        transform="matrix(.658 -.753 .753 .658 -183.203 268.281)"
      />
      <path
        d="m97.072 333.5h51.856v16h-51.856z"
        fill="#d9c7ae"
        transform="matrix(.771 -.636 .636 .771 -189.209 156.361)"
      />
      <path
        d="m169.308 288h35.384v16.001h-35.384z"
        fill="#d9c7ae"
        transform="matrix(.735 -.678 .678 .735 -151.176 205.324)"
      />
      <path d="m56 384h16v16h-16z" fill="#d9c7ae" />
      <path d="m72 424h16v16h-16z" fill="#d9c7ae" />
      <path d="m144 392h16v16h-16z" fill="#d9c7ae" />
      <g fill="#78462f">
        <path d="m400 152h16v16h-16z" />
        <path d="m424 192h16v16h-16z" />
        <path d="m440 296h16v16h-16z" />
        <path d="m264 128h16v16h-16z" />
        <path d="m304 88h16v16h-16z" />
        <path d="m415.16 331.58c-5.62 11.22-22.78 29.68-50.92 29.68-.4 0-.81 0-1.21-.02a.014.014 0 0 1 -.02 0 81.58 81.58 0 0 1 -11.01-9.24l-8.46-8.46 8.88.47a7.387 7.387 0 0 1 1.15.15c14.2 2.84 26.49.32 36.52-7.47a41.529 41.529 0 0 0 10.75-12.27z" />
        <path d="m176 167.56 1.05 9.49-16.8-16.8c1.21-18.61 6.91-33.94 16.97-45.64l12.14 10.43c-8.8 10.22-13.29 24.53-13.36 42.52z" />
        <path d="m197.789 117.442-9.085-13.17a51.608 51.608 0 0 1 17.727-8.117l3.138 15.69-1.569-7.845 1.63 7.832a37.413 37.413 0 0 0 -11.841 5.61z" />
        <path d="m353.628 321.257-9.251-13.057a51.683 51.683 0 0 0 13.655-14.466l13.936 7.862a67.352 67.352 0 0 1 -18.34 19.661z" />
        <path d="m353.03 271.78c-12.35 19.48-28.42 31.22-46.89 34.36l-15.14-15.14h5.91c16.83-.39 31.16-9.74 42.61-27.79z" />
        <path d="m360.431 258.193-14.5-6.754a102.62 102.62 0 0 0 5.83-15.451l15.485 4.012a116.424 116.424 0 0 1 -6.815 18.193z" />
      </g>
    </svg>
  ),
  corn: (props) => (
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m54.353 26.882 2.321 1.25a10.129 10.129 0 0 1 5.326 8.917 10.138 10.138 0 0 1 -.724 3.762l-1.276 3.189-1.827-2.284a7.236 7.236 0 0 0 -5.651-2.716 7.239 7.239 0 0 0 -4.5 1.567l-23.176 18.382a14.084 14.084 0 0 1 -8.755 3.051 14.091 14.091 0 0 1 -14.091-14.091 14.084 14.084 0 0 1 3.051-8.755l18.382-23.178a7.239 7.239 0 0 0 1.567-4.498 7.236 7.236 0 0 0 -2.716-5.651l-2.284-1.827 3.189-1.276a10.138 10.138 0 0 1 3.762-.724 10.129 10.129 0 0 1 8.917 5.326l1.25 2.321z"
        fill="#719301"
      />
      <path
        d="m50.3 35.3 9.965-20.7a17.536 17.536 0 0 0 1.735-7.6 5 5 0 0 0 -5-5 17.542 17.542 0 0 0 -7.609 1.737l-20.691 9.963-10.7 32.3z"
        fill="#ffd98c"
      />
      <path
        d="m60.039 3.054a17.5 17.5 0 0 0 -6.647 1.683 54.153 54.153 0 0 0 -27.912 31.763l-2.615 7.891 27.435-9.091 9.965-20.7a17.536 17.536 0 0 0 1.735-7.6 4.971 4.971 0 0 0 -1.961-3.946z"
        fill="#ffe1ae"
      />
      <path
        d="m61.127 8.959q-1.053-1.278-2.184-2.488l2.226-2.226a5.037 5.037 0 0 0 -1.414-1.414l-2.208 2.208q-1.176-1.164-2.424-2.248l.726-.726a17.446 17.446 0 0 0 -3.386.558l-2.424 2.424c-.43-.338-.874-.663-1.317-.988l-2.078 1 .486.3c.5.361 1 .733 1.485 1.112l-2.152 2.152q-1.332-1.023-2.742-1.93l.436-.436-5.457 2.627-.41.416c-.07-.037-.142-.073-.212-.111l-2.337 1.121.776.309c.1.049.2.1.295.154l-2.244 2.245c-.777-.363-1.576-.69-2.387-.994l-2.522 1.214.952.334c.835.282 1.645.611 2.443.96l-2.293 2.293c-.5-.194-1.006-.377-1.521-.543l-1.28-.343-.63 1.9 1.345.361c.177.057.349.126.524.187l-2.351 2.351-.429-.15-2.185 6.6 2.477 1.19-2.22 2.22-1.17-.656-.64 1.933.341.192-.6.6-.933 2.815.473.473 2.878-2.878.8.449a16.042 16.042 0 0 1 1.933 1.49l-7.275 7.275 1.414 1.414 7.275-7.275a16.029 16.029 0 0 1 1.493 1.937l.487.755-2.919 2.919.473.473 2.815-.933.74-.74.263.408.34-.113 1.389-.9-.545-.845 2.106-2.107 1.193 2.475 5.939-1.959-.035-.108 2.37-2.37.011.034.451 1.517 1.9-.629-.429-1.444c-.1-.366-.219-.723-.335-1.081l2.355-2.355c.35.928.669 1.872.929 2.842l.285 1.1.037-.006 1.286-2.671c-.293-.955-.613-1.9-.988-2.811l2.278-2.279c.062.135.128.268.188.4l.333.925 1.169-2.429c-.063-.134-.123-.27-.186-.4l.734-.735 2.626-5.454-.669.669q-.867-1.45-1.845-2.827l2.163-2.163c.368.505.728 1.017 1.075 1.538l.34.574 1.018-2.115c-.33-.48-.659-.959-1-1.426l2.558-2.558a17.523 17.523 0 0 0 .558-3.386zm-7.421-4.751q1.249 1.083 2.427 2.245l-2.115 2.115c-.783-.773-1.587-1.526-2.426-2.246zm-3.533 3.533c.842.716 1.65 1.465 2.434 2.238l-2.132 2.132q-1.178-1.163-2.442-2.23zm-16.373 16.378 2.16-2.16a24.769 24.769 0 0 1 2.519 2.153l-2.136 2.136a22.143 22.143 0 0 0 -2.543-2.129zm1.13 3.541-2.392 2.393a23.009 23.009 0 0 0 -2.61-2.062l2.439-2.439a20.1 20.1 0 0 1 2.558 2.108zm7.085-7.084-2.129 2.124a26.955 26.955 0 0 0 -2.507-2.165l2.141-2.141a29.716 29.716 0 0 1 2.49 2.182zm-1.07-3.606 2.13-2.131c.857.7 1.678 1.436 2.464 2.208l-2.114 2.114a32.06 32.06 0 0 0 -2.48-2.191zm-1.095 8.594a24.98 24.98 0 0 1 2.021 2.651l-2.188 2.185a22.234 22.234 0 0 0 -1.974-2.7zm1.415-1.415 2.125-2.125a29.991 29.991 0 0 1 2.075 2.6l-2.158 2.157a26.665 26.665 0 0 0 -2.042-2.632zm3.542-3.542 2.117-2.117q1.116 1.229 2.114 2.558l-2.138 2.135a32 32 0 0 0 -2.093-2.576zm3.527-3.527 2.117-2.117q1.122 1.221 2.141 2.531l-2.132 2.132q-1.006-1.32-2.126-2.546zm-1.719-5.78q1.271 1.061 2.446 2.225l-2.113 2.114q-1.179-1.158-2.46-2.212zm-4.337-3.164c.949.6 1.865 1.241 2.758 1.914l-2.136 2.134q-1.353-.994-2.8-1.869zm-3.637 3.637q1.461.855 2.831 1.841l-2.148 2.148a31.779 31.779 0 0 0 -2.878-1.794zm-3.677 3.677a29.883 29.883 0 0 1 2.921 1.75l-2.165 2.166a27.037 27.037 0 0 0 -2.991-1.681zm-3.737 3.737a24.976 24.976 0 0 1 3.054 1.618l-2.2 2.2a21.807 21.807 0 0 0 -3.155-1.517zm-6.173 6.174 2.321-2.322.5.174a19.743 19.743 0 0 1 2.739 1.257l-2.441 2.441c-.19-.106-.373-.222-.567-.323zm3.925 8.246a18.277 18.277 0 0 0 -2.314-1.793l-.362-.2 2.183-2.182a20.917 20.917 0 0 1 2.634 2.037zm3.43 4.07-.252-.39a17.942 17.942 0 0 0 -1.757-2.268l2.14-2.14a20.955 20.955 0 0 1 2.038 2.634zm1.539-6.211 2.345-2.345a20.042 20.042 0 0 1 1.937 2.735l-2.22 2.219a23.04 23.04 0 0 0 -2.062-2.609zm4.694 7.478-1.242-2.582c-.1-.184-.207-.357-.307-.538l2.107-2.108a19.8 19.8 0 0 1 .963 2.53l.287.892zm3.394-3.394a21.728 21.728 0 0 0 -1.336-3.337l2.226-2.226a25 25 0 0 1 1.466 3.206zm3.908-3.908a27.056 27.056 0 0 0 -1.544-3.131l2.183-2.183a29.546 29.546 0 0 1 1.63 3.042zm3.774-3.774a31.854 31.854 0 0 0 -1.674-3l2.166-2.168c.627.948 1.2 1.929 1.737 2.935zm5.9-5.9-2.194 2.2c-.548-.994-1.143-1.959-1.777-2.9l2.146-2.146c.644.924 1.257 1.871 1.823 2.847zm-1.6-5.9q-1.026-1.3-2.148-2.524l2.13-2.129c.752.81 1.478 1.641 2.167 2.5zm3.571-3.568c-.694-.86-1.425-1.687-2.177-2.495l2.116-2.116q1.131 1.21 2.178 2.494z"
        fill="#f9cb5d"
      />
      <path
        d="m16.667 41.675.026-.013a27 27 0 0 1 6.974-2.362l20.865-4.012a15.879 15.879 0 0 1 3-.286 13.161 13.161 0 0 1 12.486 9l-1.828-2.286a7.237 7.237 0 0 0 -10.148-1.149l-23.178 18.382a14.073 14.073 0 0 1 -20.881-3.888 26.99 26.99 0 0 1 12.684-13.386z"
        fill="#82ab00"
      />
      <path
        d="m22.325 47.351.013-.027a27 27 0 0 0 2.362-6.974l4.012-20.864a15.887 15.887 0 0 0 .286-3 13.162 13.162 0 0 0 -8.998-12.486l2.284 1.827a7.238 7.238 0 0 1 1.149 10.149l-18.382 23.178a14.073 14.073 0 0 0 3.888 20.881 26.99 26.99 0 0 0 13.386-12.684z"
        fill="#8dbf00"
      />
    </svg>
  ),
  avocado: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m170.5 126.5a7.5 7.5 0 0 1 -7.5-7.5v-93.5a7.5 7.5 0 0 1 15 0v93.5a7.5 7.5 0 0 1 -7.5 7.5z"
        fill="#c1773d"
      />
      <path
        d="m266.962 188.2q.255-3.9.191-7.871c-.857-51.309-43.313-93.112-95.28-93.824-54.017-.74-98.04 42.272-98.04 95.436q0 2.693.15 5.35c1.433 25.616-5.488 51.131-20.783 71.871a141.289 141.289 0 0 0 -27.7 84.2c.018 80.607 68.379 145.766 149.971 143.052 77.78-2.583 140.029-65.654 140.029-143.081a141.3 141.3 0 0 0 -28.271-84.933c-15.091-20.183-21.908-45.163-20.267-70.2z"
        fill="#80b524"
      />
      <path
        d="m163 80.5v-.167a54.834 54.834 0 0 0 -54.834-54.833h-27.166v.167a54.833 54.833 0 0 0 54.832 54.833z"
        fill="#8bc932"
      />
      <path
        d="m315.5 343.33c0 55.22-31.66 103.13-78.03 127.02-55.41-26.6-94.13-83.27-94.14-148.81a164.2 164.2 0 0 1 31.52-97.04c17.41-23.91 25.28-53.31 23.65-82.83-.11-2.05-.17-4.1-.17-6.17a109.5 109.5 0 0 1 8.33-42.04c34.9 14.02 59.83 47.67 60.49 86.87.04 2.65-.02 5.28-.19 7.87-1.64 25.04 5.18 50.02 20.27 70.2a141.336 141.336 0 0 1 28.27 84.93z"
        fill="#76a51c"
      />
      <path
        d="m190.61 485.128a145.071 145.071 0 0 1 -15.14 1.29c-81.59 2.71-149.95-62.449-149.97-143.049a141.227 141.227 0 0 1 27.7-84.2c15.3-20.74 22.22-46.26 20.78-71.88-.1-1.77-.15-3.55-.15-5.35 0-53.16 44.03-96.17 98.04-95.43a97.276 97.276 0 0 1 18.59 2.05c-43.77 9.11-76.63 47.46-76.63 93.38 0 1.8.05 3.58.15 5.35 1.44 25.62-5.48 51.14-20.78 71.88a141.227 141.227 0 0 0 -27.7 84.2c.02 72.25 54.95 132.099 125.11 141.759z"
        fill="#76a51c"
      />
      <path
        d="m150.83 80.5h-15a54.832 54.832 0 0 1 -54.83-54.83v-.17h15v.17a54.832 54.832 0 0 0 54.83 54.83z"
        fill="#80b524"
      />
      <path
        d="m431.267 142.714q.291-4.489.218-9.071c-.976-59.134-49.285-107.312-108.423-108.132a110 110 0 0 0 -111.562 109.989q0 3.1.17 6.166c1.631 29.523-6.245 58.929-23.649 82.832a164.217 164.217 0 0 0 -31.521 97.04c.021 92.9 77.81 168 170.657 164.868a165.006 165.006 0 0 0 127.173-262.794c-17.173-23.258-24.93-52.048-23.063-80.898z"
        fill="#8bc932"
      />
      <path
        d="m321.565 456.5a135.006 135.006 0 0 1 -109.293-214.344c20.977-28.806 31.4-65.082 29.352-102.146-.082-1.5-.124-3.015-.124-4.51a80.091 80.091 0 0 1 80-80q.571 0 1.146.008c42.768.593 78.137 35.866 78.842 78.629.037 2.212-.016 4.446-.158 6.642-2.363 36.494 7.889 72.242 28.866 100.653a135 135 0 0 1 -104.049 214.991c-1.543.052-3.036.077-4.565.077z"
        fill="#f9d36b"
      />
      <path
        d="m411.5 321.5a90 90 0 0 1 -180 0c0-49.706 40.294-110 90-110s90 60.294 90 110z"
        fill="#d88646"
      />
      <path
        d="m329.03 456.29c-.96.06-1.92.1-2.88.13-1.55.05-3.04.08-4.57.08h-.01a135 135 0 0 1 -109.3-214.34c20.98-28.81 31.4-65.09 29.35-102.15-.08-1.5-.12-3.02-.12-4.51a80.093 80.093 0 0 1 80-80c.38 0 .76 0 1.15.01q3.18.045 6.3.34a80.126 80.126 0 0 0 -72.45 79.65c0 1.49.04 3.01.12 4.51 2.05 37.06-8.37 73.34-29.35 102.15a135.256 135.256 0 0 0 101.76 214.13z"
        fill="#ffc443"
      />
      <path
        d="m398.35 368.35a90 90 0 0 1 -166.85-46.85c0-36.32 21.5-78.28 52.47-98.26-13.99 20.41-22.47 45.45-22.47 68.26a90.007 90.007 0 0 0 136.85 76.85z"
        fill="#c1773d"
      />
    </svg>
  ),
  salad: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m291.423 410.048-.04-75.518-1.441-.542-.572.676-33.37 57.798-1-1.732v89.614l1 5.212c41.712 0 75.839-34.128 75.839-75.839v-23.032z"
          fill="#edf9d9"
        ></path>
        <path
          d="m256 392.462-33.796-58.537-1.439.551-.149.746-.04 74.826-40.416-23.363v23.032c0 41.711 34.128 75.839 75.839 75.839z"
          fill="#dbf4b2"
        ></path>
        <g>
          <path
            d="m215.187 415.688c-.034-.056-.075-.105-.108-.162l-6.489-11.253-28.429-16.433v21.876c0 35.428 24.626 65.373 57.602 73.594-13.917-13.769-22.576-32.843-22.576-53.845z"
            fill="#d1f19e"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m218.24 327.061-.684.114c-2.895.484-5.751.729-8.49.729-28.203 0-51.148-22.945-51.148-51.148 0-12.725 4.704-24.921 13.245-34.342l.609-.672-.609-.672c-8.541-9.421-13.245-21.618-13.245-34.342s4.704-24.921 13.245-34.342l.609-.672-.609-.672c-8.541-9.421-13.245-21.617-13.245-34.342 0-5.677.916-11.137 2.603-16.242-14.432-8.736-32.703-10.217-48.796-2.811-.807-1.88-1.718-3.737-2.765-5.553-14.386-24.948-46.275-33.511-71.225-19.124s-33.512 46.276-19.125 71.226c1.047 1.816 2.197 3.534 3.421 5.175-21.765 15.368-28.624 45.072-15.052 68.609 6.732 11.675 17.297 19.76 29.19 23.586-2.646 12.209-.94 25.403 5.792 37.078s17.297 19.76 29.19 23.586c-2.646 12.209-.94 25.403 5.792 37.078 14.387 24.95 46.276 33.512 71.226 19.125 2.557-1.474 4.921-3.151 7.126-4.967l66.281 38.314.041-76.558c.364-.136.726-.286 1.089-.43z"
              fill="#bbec6c"
            ></path>
            <g>
              <g>
                <path
                  d="m120.619 350.844c-6.732-11.675-8.438-24.869-5.792-37.078-11.892-3.826-22.457-11.911-29.19-23.586-6.732-11.675-8.438-24.869-5.792-37.078-11.892-3.826-22.457-11.911-29.19-23.586-13.572-23.536-6.714-53.24 15.051-68.609-1.223-1.64-2.374-3.359-3.421-5.175-13.427-23.284-6.86-52.607 14.355-68.112-12.71-3.236-26.644-1.72-38.905 5.35-24.95 14.387-33.512 46.276-19.125 71.226 1.047 1.816 2.197 3.534 3.421 5.175-21.765 15.368-28.624 45.072-15.052 68.609 6.732 11.675 17.297 19.76 29.19 23.586-2.646 12.209-.94 25.403 5.792 37.078s17.297 19.76 29.19 23.586c-2.646 12.209-.94 25.403 5.792 37.078 14.387 24.95 46.276 33.513 71.226 19.125 1.661-.958 3.234-2.009 4.742-3.12-13.145-3.353-24.98-11.789-32.292-24.469z"
                  fill="#a2e62e"
                ></path>
              </g>
            </g>
            <path
              d="m187.375 337.457 1.495-13.717c-5.2-2.244-9.959-5.323-14.1-9.073l-.085.782-1.097-1.903c-6.843-6.602-11.854-15.083-14.191-24.61l-1.151-1.996.263-2.415c-.388-2.534-.589-5.128-.589-7.769 0-6.39 1.188-12.646 3.45-18.484l2.921-26.81c-4.154-7.511-6.371-15.998-6.371-24.734 0-1.458.069-2.909.192-4.35-3.342.448-6.079 3.111-6.461 6.612l-6.096 55.941-16.44-28.509 8.317-76.324c.449-4.118-2.526-7.82-6.644-8.269-4.116-.441-7.819 2.526-8.269 6.644l-6.096 55.941-34.232-59.364c-2.069-3.589-6.656-4.82-10.244-2.75-3.588 2.069-4.82 6.655-2.75 10.244l34.232 59.364-51.47-22.746c-3.789-1.675-8.217.039-9.892 3.828-1.674 3.789.04 8.217 3.828 9.892l70.225 31.034 16.439 28.509-51.47-22.746c-3.79-1.675-8.218.039-9.892 3.828s.04 8.217 3.828 9.892l70.224 31.034 16.439 28.509-51.47-22.746c-3.788-1.674-8.217.04-9.892 3.828-1.674 3.789.04 8.217 3.828 9.892l70.224 31.034 40.698 70.578c1.389 2.408 3.911 3.755 6.504 3.755 1.271 0 2.56-.324 3.74-1.004 3.588-2.069 4.82-6.655 2.75-10.244z"
              fill="#97d729"
            ></path>
          </g>
          <g>
            <path
              d="m489.969 169.371c1.223-1.64 2.374-3.359 3.421-5.175 14.387-24.95 5.824-56.839-19.125-71.226-24.95-14.387-56.839-5.824-71.226 19.125-1.047 1.816-1.958 3.672-2.765 5.553-16.093-7.406-34.364-5.925-48.796 2.811 1.687 5.105 2.603 10.564 2.603 16.242 0 12.725-4.704 24.921-13.245 34.342l-.609.672.609.672c8.541 9.421 13.245 21.617 13.245 34.342s-4.704 24.921-13.245 34.342l-.609.672.609.672c8.541 9.42 13.245 21.617 13.245 34.342 0 28.203-22.945 51.148-51.148 51.148-2.739 0-5.595-.246-8.49-.729l-.684-.114-4.464 7.732c.363.144.724.294 1.089.43l.041 76.558 66.281-38.314c2.206 1.816 4.569 3.493 7.126 4.967 24.95 14.387 56.839 5.825 71.226-19.125 6.732-11.675 8.438-24.869 5.792-37.078 11.892-3.826 22.457-11.911 29.19-23.586s8.438-24.869 5.792-37.078c11.892-3.826 22.457-11.911 29.19-23.586 13.571-23.539 6.712-53.243-15.053-68.611z"
              fill="#a2e62e"
            ></path>
            <g fill="#97d729">
              <path d="m471.07 203.712c-1.626-3.81-6.034-5.581-9.842-3.955l-52.902 22.574 34.476-59.787c2.069-3.588.838-8.175-2.75-10.244s-8.174-.838-10.244 2.75l-34.476 59.787-6.962-57.093c-.501-4.112-4.243-7.039-8.353-6.537-4.112.501-7.039 4.241-6.537 8.353l9.379 76.908-16.657 28.886-6.962-57.093c-.376-3.083-2.572-5.502-5.381-6.306.147 1.58.222 3.172.222 4.773 0 9.155-2.446 18.03-6.993 25.801l2.97 24.352c2.629 6.232 4.023 12.974 4.023 19.875 0 2.715-.217 5.379-.627 7.981l.274 2.248-1.125 1.95c-2.337 9.527-7.348 18.008-14.191 24.61l-1.341 2.326-.118-.965c-4.131 3.688-8.858 6.721-14.023 8.924l1.667 13.673-40.672 70.531c-2.069 3.588-.838 8.175 2.75 10.244 1.18.681 2.468 1.004 3.74 1.004 2.593 0 5.115-1.347 6.504-3.755l40.672-70.531 71.262-30.408c3.81-1.626 5.581-6.032 3.955-9.842s-6.033-5.582-9.842-3.955l-52.902 22.574 16.657-28.885 71.262-30.408c3.81-1.626 5.581-6.032 3.955-9.842s-6.033-5.581-9.842-3.955l-52.902 22.574 16.657-28.885 71.262-30.408c3.812-1.628 5.583-6.034 3.957-9.844z"></path>
              <path d="m474.265 92.97c-24.95-14.387-56.839-5.824-71.226 19.125-1.047 1.816-1.958 3.672-2.765 5.553-15.778-7.261-33.652-5.983-47.946 2.303 1.783 5.257 2.754 10.889 2.754 16.75 0 13.477-5.113 25.759-13.504 35.014.361.398.707.809 1.056 1.218 13.782-22.886 42.494-31.482 66.397-20.481.807-1.88 1.718-3.737 2.765-5.553 14.387-24.95 46.276-33.512 71.226-19.125 7.039 4.059 12.773 9.512 17.056 15.809 2.068-19.854-7.404-39.998-25.813-50.613z"></path>
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m341.577 171.714c8.391-9.255 13.504-21.537 13.504-35.014 0-27.169-20.78-49.475-47.312-51.917.241-2.032.378-4.095.378-6.192 0-28.801-23.348-52.148-52.148-52.148s-52.148 23.348-52.148 52.148c0 2.096.138 4.16.378 6.192-26.532 2.441-47.312 24.748-47.312 51.917 0 13.477 5.113 25.759 13.504 35.014-8.391 9.255-13.504 21.537-13.504 35.014s5.113 25.759 13.504 35.014c-8.391 9.255-13.504 21.537-13.504 35.014 0 28.801 23.348 52.148 52.148 52.148 2.952 0 5.837-.272 8.655-.743l38.28 66.301 38.279-66.301c2.818.471 5.703.743 8.655.743 28.801 0 52.148-23.348 52.148-52.148 0-13.477-5.113-25.759-13.504-35.014 8.391-9.255 13.504-21.537 13.504-35.014s-5.114-25.758-13.505-35.014z"
              fill="#bbec6c"
            ></path>
          </g>
          <g>
            <path
              d="m271.756 314.17c-1.001-1.734-2.937-2.676-4.928-2.462-1.776.191-3.579.295-5.406.295-28.801 0-52.148-23.348-52.148-52.148 0-13.477 5.113-25.759 13.504-35.014-8.391-9.255-13.504-21.537-13.504-35.014s5.113-25.759 13.504-35.014c-8.391-9.255-13.504-21.537-13.504-35.014 0-27.169 20.78-49.475 47.312-51.917-.24-2.032-.378-4.095-.378-6.191 0-12.857 4.662-24.619 12.375-33.71-4.03-.999-8.242-1.538-12.582-1.538-28.801 0-52.148 23.348-52.148 52.148 0 2.096.138 4.16.379 6.192-26.532 2.441-47.312 24.747-47.312 51.917 0 13.477 5.113 25.759 13.504 35.014-8.391 9.255-13.504 21.537-13.504 35.014s5.113 25.759 13.504 35.014c-8.391 9.255-13.504 21.537-13.504 35.014 0 28.801 23.348 52.148 52.148 52.148 2.952 0 5.837-.272 8.655-.743l38.277 66.301 31.056-53.791z"
              fill="#a2e62e"
            ></path>
          </g>
          <path
            d="m310.397 251.126c2.5-3.302 1.851-8.006-1.451-10.507s-8.007-1.851-10.507 1.451l-34.939 46.142v-33.466l46.897-61.934c2.5-3.302 1.851-8.006-1.452-10.506-3.302-2.501-8.006-1.851-10.506 1.451l-34.939 46.142v-33.466l46.897-61.934c2.5-3.302 1.851-8.006-1.452-10.506-3.302-2.501-8.006-1.851-10.506 1.452l-34.939 46.14v-61.258c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v61.257l-34.939-46.141c-2.5-3.302-7.203-3.953-10.507-1.451-3.302 2.5-3.952 7.205-1.451 10.507l46.897 61.933v33.466l-34.939-46.141c-2.5-3.301-7.203-3.953-10.507-1.451-3.302 2.5-3.952 7.205-1.451 10.507l46.897 61.933v33.466l-34.939-46.14c-2.499-3.302-7.204-3.952-10.507-1.451-3.302 2.5-3.952 7.205-1.451 10.507l46.897 61.932v81.403c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-81.403z"
            fill="#97d729"
          ></path>
        </g>
      </g>
    </svg>
  ),
  'yellow-pepper': (props) => (
    <svg
      id="fi_2909848"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      {...props}
    >
      <path
        d="m272.97 111.39a355.479 355.479 0 0 1 1.98 39.31l-1.67 1.55a97.176 97.176 0 0 0 -44.3 2.28l-.51-1.66c.58-7.04 1.25-13.9 1.89-20.52 5.21-53.76 8.46-92.51-55.63-97.83l-.5-23.28c69.35-4.03 92.52 44.05 98.74 100.15z"
        fill="#4b651a"
      ></path>
      <path
        d="m272.97 111.39c-6.22-56.1-29.39-104.18-98.74-100.15l.01.442c53.439 5.888 72.524 49.6 78.08 99.708a355.479 355.479 0 0 1 1.98 39.31l-.031.029c.577-.009 1.151-.029 1.731-.029a94.691 94.691 0 0 1 17.28 1.55l1.67-1.55a355.479 355.479 0 0 0 -1.98-39.31z"
        fill="#689b2d"
      ></path>
      <path
        d="m200.97 459.85c-11.94 14.77-23 23.47-29.17 23.47-50.99 0-69.73-65.5-69.73-139.16 0-58.35-49.79-107.87-33.34-162 7.7-25.36 29.55-39.33 50.79-43.27 11.31-2.1 22.8-.67 34.06 3.78 14.59 5.76 28.8 16.61 41.71 31.44a83.147 83.147 0 0 1 33.69-19.58 97.176 97.176 0 0 1 44.3-2.28 83.387 83.387 0 0 1 43.22 22.1c13.95-16.09 29.41-27.52 45.25-32.9a60.226 60.226 0 0 1 30.73-2.56c21.24 3.94 43.09 17.91 50.79 43.27 16.45 54.13-33.34 103.65-33.34 162 0 73.66-16.48 139.16-69.73 139.16-7.02 0-18.06-8.23-29.7-22.25-15.62 24.43-34.35 39.93-54.5 39.93-20.38 0-39.32-16.02-55.03-41.15z"
        fill="#ffd400"
      ></path>
      <path
        d="m216.368 345.356c-11.1-62.888-74.191-106.784-66.763-168.254a64.56 64.56 0 0 1 12.089-30.686 81.109 81.109 0 0 0 -8.114-3.746c-11.26-4.45-22.75-5.88-34.06-3.78-21.24 3.94-43.09 17.91-50.79 43.27-16.45 54.13 33.34 103.65 33.34 162 0 73.66 18.74 139.16 69.73 139.16 6.17 0 17.23-8.7 29.17-23.47 15.71 25.13 34.65 41.15 55.03 41.15 13.744 0 26.826-7.216 38.713-19.553-41.063-10.129-66.435-68.647-78.345-136.091z"
        fill="#edc003"
      ></path>
      <path
        d="m361.75 141.45c-15.84 5.38-31.3 16.81-45.25 32.9a83.387 83.387 0 0 0 -43.22-22.1l1.67-1.55a355.479 355.479 0 0 0 -1.98-39.31c44.33-14.43 71.14 8.36 88.78 30.06z"
        fill="#e5bd41"
      ></path>
      <path
        d="m230.12 132.33.24.02c-.64 6.62-1.31 13.48-1.89 20.52l.51 1.66a83.147 83.147 0 0 0 -33.69 19.58c-12.91-14.83-27.12-25.68-41.71-31.44 6.92-23.48 54.09-36.24 76.54-10.34z"
        fill="#e5bd41"
      ></path>
      <g opacity=".6">
        <path
          d="m117.2 271a6 6 0 0 1 -5.576-3.78c-1.933-4.85-4.187-10.592-6.251-16.4-1.611-4.546-2.95-8.663-4.095-12.588a144.277 144.277 0 0 1 -3.681-15.64 107.232 107.232 0 0 1 -1.514-13.8 6 6 0 0 1 11.99-.5 95.163 95.163 0 0 0 1.347 12.244 132.242 132.242 0 0 0 3.38 14.339c1.078 3.7 2.349 7.6 3.883 11.931 2 5.618 4.2 11.227 6.089 15.973a6 6 0 0 1 -5.572 8.221z"
          fill="#e9e9e9"
        ></path>
      </g>
      <g opacity=".6">
        <path
          d="m132.7 312.841a6 6 0 0 1 -5.754-4.306c-1.138-3.867-2.468-7.927-4.066-12.411a6 6 0 1 1 11.3-4.028c1.673 4.7 3.071 8.966 4.274 13.049a6 6 0 0 1 -5.758 7.7z"
          fill="#e9e9e9"
        ></path>
      </g>
    </svg>
  ),
  'red-onion': (props) => (
    <svg
      id="fi_2923216"
      enable-background="new 0 0 468.001 468.001"
      height="512"
      viewBox="0 0 468.001 468.001"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="m212.392 48.013c13.839 39.396 14.121 82.432.121 121.771-5.002 14.055-10.802 24.515-16.986 24.515s-11.984-10.46-16.986-24.515c-14-39.338-13.718-82.375.121-121.771l16.865-48.013z"
                fill="#a8db58"
              ></path>
            </g>
            <g>
              <path
                d="m178.661 80.434 16.865-48.013 16.865 48.013c5.147 14.653 8.415 29.81 9.774 45.093 2.321-26.054-.994-52.517-9.774-77.514l-16.864-48.013-16.865 48.013c-8.781 24.998-12.095 51.46-9.774 77.514 1.358-15.283 4.626-30.44 9.773-45.093z"
                fill="#8ecc3e"
              ></path>
            </g>
            <g>
              <path
                d="m148.709 132.25h37.758l3.979-27.136c6.778-46.221-41.264-80.856-82.765-59.668 29.806 13.542 47.078 45.242 42.35 77.725z"
                fill="#8ecc3e"
              ></path>
            </g>
            <g>
              <path
                d="m107.681 45.445c2.637 1.198 5.171 2.546 7.605 4.016 35.071-3.334 67.652 27.18 61.992 65.784l-2.493 17.005h11.682l3.979-27.136c6.777-46.221-41.264-80.856-82.765-59.669z"
                fill="#75af23"
              ></path>
            </g>
            <g>
              <path
                d="m243.219 132.25h-37.758l-3.979-27.136c-6.778-46.221 41.264-80.856 82.765-59.668-29.806 13.542-47.078 45.242-42.35 77.725z"
                fill="#8ecc3e"
              ></path>
            </g>
            <g>
              <path
                d="m214.651 117.272c-5.506-37.548 25.166-67.45 59.119-65.991 3.289-2.201 6.787-4.158 10.478-5.836-41.501-21.187-89.543 13.448-82.765 59.668l3.979 27.136h11.385z"
                fill="#75af23"
              ></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="m221.382 462.941c-3.313 0-6-2.687-6-6v-12.082c0-3.313 2.687-6 6-6s6 2.687 6 6v12.082c0 3.313-2.686 6-6 6z"
                fill="#913a8d"
              ></path>
            </g>
            <g>
              <path
                d="m170.545 464.206c-3.313 0-6-2.686-6-5.999l-.003-13.569c0-3.314 2.685-6.001 5.999-6.001h.001c3.313 0 6 2.686 6 5.999l.003 13.569c0 3.314-2.685 6.001-5.999 6.001z"
                fill="#913a8d"
              ></path>
            </g>
            <g>
              <path
                d="m246.801 456.615c-3.313 0-5.999-2.685-6-5.999l-.003-11.118c-.001-3.313 2.685-6 5.999-6.001h.001c3.313 0 5.999 2.685 6 5.999l.003 11.118c.001 3.313-2.685 6-5.999 6.001z"
                fill="#913a8d"
              ></path>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m244.251 91.656-23.412 30.825-24.875-51.025-23.657 50.151-24.631-29.951.133.36c9.942 26.884-2.292 56.929-28.157 69.129-51.822 24.444-90.652 72.547-90.652 131.115 0 85.197 83.336 154.106 166.962 154.262 101.711.19 167.414-79.172 166.962-154.262-.353-58.595-38.765-106.997-90.527-131.413-25.889-12.211-38.127-42.291-28.146-69.191z"
                  fill="#ba4aa5"
                ></path>
              </g>
              <g>
                <path
                  d="m297.255 324.944c-83.626-.156-166.962-69.066-166.962-154.262 0-5.793.394-11.478 1.129-17.054-3.52 2.935-7.449 5.48-11.769 7.518-51.822 24.444-90.652 72.547-90.652 131.115 0 85.197 83.336 154.106 166.962 154.262 92.155.172 154.75-64.961 165.362-133.053-19.211 7.347-40.686 11.517-64.07 11.474z"
                  fill="#af46a0"
                ></path>
              </g>
              <g>
                <path
                  d="m362.925 292.261c-.247-40.969-19.113-76.941-48.126-103.229-.804-.013-1.607-.031-2.415-.031-80.971 0-146.611 65.773-146.611 146.908 0 43.624 18.983 82.8 49.115 109.706 90.86-8.964 148.461-83.031 148.037-153.354z"
                  fill="#9e3f95"
                ></path>
              </g>
              <g>
                <path
                  d="m62.427 301.379c0-58.568 38.83-106.671 90.652-131.115 25.579-12.065 37.812-41.582 28.463-68.236l-9.235 19.579-24.631-29.951.133.36c9.942 26.884-2.292 56.929-28.157 69.129-51.822 24.444-90.652 72.547-90.652 131.115 0 76.466 67.133 139.8 141.353 152.093-59.802-22.909-107.926-78.234-107.926-142.974z"
                  fill="#9e3f95"
                ></path>
              </g>
            </g>
            <path
              d="m150.832 433.97c-48.264-33.965-77.079-87.119-77.079-142.188 0-26.408 6.327-51.623 18.804-74.945 1.563-2.922.461-6.558-2.46-8.121-2.923-1.563-6.558-.461-8.121 2.46-13.419 25.083-20.223 52.203-20.223 80.606 0 57.895 29.626 113.709 79.399 149.99v8.842c0 3.313 2.687 6 6 6s6-2.687 6-6v-10.126c.664-2.377-.186-5.016-2.32-6.518z"
              fill="#913a8d"
            ></path>
            <g>
              <path
                d="m248.904 444.878c-1.808 0-3.594-.813-4.775-2.362-2.009-2.635-1.502-6.4 1.132-8.41 44.581-33.999 73.199-89.851 72.91-142.29-.146-26.453-6.5-51.685-18.888-74.997-1.555-2.926-.443-6.559 2.483-8.114 2.927-1.554 6.559-.443 8.114 2.483 13.308 25.043 20.135 52.148 20.292 80.561.309 56.073-30.164 115.696-77.633 151.898-1.087.83-2.366 1.231-3.635 1.231z"
                fill="#913a8d"
              ></path>
            </g>
            <path
              d="m279.062 231.786c-1.152-3.107-4.605-4.692-7.711-3.541-3.107 1.152-4.692 4.604-3.541 7.711 6.591 17.781 9.988 36.575 10.094 55.859.274 49.78-23.599 99.475-62.458 133.003 12.658-24.446 21.431-51.002 26.147-79.278 5.991-35.924 5.216-72.885-2.303-109.856-.66-3.247-3.827-5.343-7.075-4.684-3.247.66-5.344 3.828-4.684 7.075 14.425 70.927 3.144 140.514-31.712 197.054-36.031-58.59-47.697-130.878-31.926-199.921.738-3.23-1.283-6.447-4.513-7.185-3.23-.74-6.448 1.283-7.185 4.513-14.966 65.521-6.259 133.878 23.721 191.778-38.72-33.569-61.893-82.213-61.893-132.533 0-19.478 3.066-38.307 9.114-55.962 1.074-3.135-.597-6.547-3.732-7.621-3.137-1.074-6.547.597-7.621 3.732-6.477 18.91-9.761 39.047-9.761 59.851 0 62.723 33.622 122.948 87.942 158.014v12.204c0 3.313 2.687 6 6 6s6-2.687 6-6v-12.193c26.095-16.751 48.099-40.204 63.752-68.055 15.991-28.454 24.355-59.576 24.188-90.003-.116-20.688-3.764-40.863-10.843-59.962z"
              fill="#913a8d"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <g>
              <ellipse cx="312.385" cy="335.909" fill="#e086dc" rx="126.616" ry="126.645"></ellipse>
            </g>
            <g>
              <ellipse cx="312.385" cy="335.909" fill="#ffddf4" rx="113.13" ry="112.954"></ellipse>
            </g>
          </g>
          <g>
            <g>
              <path
                d="m312.385 429.387c-51.532 0-93.455-41.934-93.455-93.477s41.924-93.477 93.455-93.477 93.456 41.934 93.456 93.477-41.924 93.477-93.456 93.477z"
                fill="#e086dc"
              ></path>
            </g>
            <g>
              <path
                d="m312.385 417.318c-44.878 0-81.389-36.519-81.389-81.408s36.511-81.408 81.389-81.408 81.39 36.519 81.39 81.408-36.512 81.408-81.39 81.408z"
                fill="#ffddf4"
              ></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="m312.385 396.219c-33.247 0-60.296-27.055-60.296-60.31s27.048-60.31 60.296-60.31 60.296 27.055 60.296 60.31-27.049 60.31-60.296 60.31z"
                fill="#e086dc"
              ></path>
            </g>
            <g>
              <path
                d="m312.385 385.263c-27.208 0-49.342-22.14-49.342-49.354s22.135-49.354 49.342-49.354c27.208 0 49.343 22.14 49.343 49.354s-22.136 49.354-49.343 49.354z"
                fill="#ffddf4"
              ></path>
            </g>
          </g>
          <g>
            <g>
              <path
                d="m312.385 363.051c-14.962 0-27.136-12.176-27.136-27.142s12.173-27.142 27.136-27.142 27.136 12.176 27.136 27.142-12.173 27.142-27.136 27.142z"
                fill="#e2a1dc"
              ></path>
            </g>
            <g>
              <path
                d="m312.385 351.173c-8.415 0-15.26-6.848-15.26-15.264s6.846-15.264 15.26-15.264c8.415 0 15.261 6.848 15.261 15.264s-6.846 15.264-15.261 15.264z"
                fill="#ffddf4"
              ></path>
            </g>
          </g>
        </g>
        <path
          d="m356.107 44.838h-10.207v-10.211c0-3.314-2.687-6-6-6-3.314 0-6 2.687-6 6v10.211h-10.207c-3.313 0-6 2.687-6 6s2.687 6 6 6h10.207v10.21c0 3.314 2.687 6 6 6 3.314 0 6-2.687 6-6v-10.21h10.207c3.313 0 6-2.687 6-6s-2.687-6-6-6z"
          fill="#af46a0"
        ></path>
        <g>
          <path
            d="m66.479 138.888c-13.92 0-25.246-11.493-25.246-25.621s11.325-25.621 25.246-25.621 25.246 11.494 25.246 25.621-11.326 25.621-25.246 25.621zm0-39.241c-7.304 0-13.246 6.11-13.246 13.621 0 7.51 5.942 13.621 13.246 13.621s13.246-6.11 13.246-13.621c-.001-7.511-5.943-13.621-13.246-13.621z"
            fill="#e0e0e0"
          ></path>
        </g>
        <g>
          <path
            d="m400.744 209.439c-13.92 0-25.246-11.327-25.246-25.25s11.325-25.25 25.246-25.25 25.246 11.327 25.246 25.25c-.001 13.923-11.326 25.25-25.246 25.25zm0-38.5c-7.304 0-13.246 5.944-13.246 13.25s5.942 13.25 13.246 13.25 13.246-5.944 13.246-13.25-5.943-13.25-13.246-13.25z"
            fill="#e0e0e0"
          ></path>
        </g>
        <g>
          <ellipse cx="233.84" cy="176.809" fill="#fff" rx="11.001" ry="17.248"></ellipse>
        </g>
        <g>
          <path
            d="m200.927 200.555c.302 6.236-2.858 11.135-7.057 10.942s-7.848-5.404-8.15-11.639c-.302-6.236 2.858-11.135 7.057-10.942s7.848 5.404 8.15 11.639z"
            fill="#fff"
          ></path>
        </g>
        <g>
          <path
            d="m249.826 317.54c.201 4.143-1.899 7.397-4.688 7.269s-5.214-3.59-5.414-7.733 1.899-7.397 4.688-7.269c2.79.128 5.214 3.59 5.414 7.733z"
            fill="#fff"
          ></path>
        </g>
      </g>
    </svg>
  ),
  'red-pepper': (props) => (
    <svg
      id="fi_5346673"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              d="m110.096 127.454h37.526c7.16 0 14.044 1.185 20.488 3.34 8.832-15.781 21.839-29.04 37.826-38.158-10.543-4.749-22.205-7.417-34.467-7.417-31.605 0-59.288 17.588-73.786 43.45 4.054-.793 8.195-1.215 12.413-1.215z"
              fill="#fe646f"
            ></path>
          </g>
          <g>
            <path
              d="m340.532 85.219c-12.294 0-23.985 2.682-34.55 7.454 11.827 6.794 22.317 15.965 30.553 26.912 2.71 3.602 5.143 7.353 7.322 11.219 6.453-2.162 13.349-3.351 20.521-3.351h37.525c4.218 0 8.359.422 12.414 1.216-14.498-25.862-42.18-43.45-73.785-43.45z"
              fill="#fe646f"
            ></path>
          </g>
        </g>
        <path
          d="m189.207 142.618c9.769-9.38 23.017-15.164 37.598-15.164h58.39c14.581 0 27.828 5.784 37.597 15.164 6.406-5.379 13.861-9.544 22.014-12.135-12.692-22.677-33.803-40.004-59.117-47.718-4.409-1.344-6.47-6.471-3.987-10.354 11.972-18.729 32.938-31.176 56.767-31.176h13.655c3.845 0 6.962-3.117 6.962-6.962v-27.311c0-3.845-3.117-6.962-6.962-6.962h-13.654c-48.945 0-90.419 32.557-103.932 77.149-.688 2.269-2.495 4.038-4.786 4.648-26.834 7.15-49.289 24.997-62.553 48.688 8.151 2.59 15.604 6.755 22.008 12.133z"
          fill="#0ed290"
        ></path>
        <path
          d="m189.207 142.618c9.769-9.38 23.017-15.164 37.598-15.164h14.491c-1.816-23.815 9.119-51.798 31.306-73.985 26.217-26.217 60.525-36.728 86.485-29.04v-17.467c0-3.845-3.117-6.962-6.962-6.962h-13.655c-48.945 0-90.419 32.557-103.932 77.149-.688 2.269-2.495 4.037-4.786 4.648-26.834 7.15-49.289 24.997-62.553 48.688 8.151 2.59 15.604 6.755 22.008 12.133z"
          fill="#00c285"
        ></path>
        <g>
          <path
            d="m172.468 427.543 7.438-49.605c6.619-44.141 6.963-88.952 1.024-133.188l-8.462-63.026c.019-15.697 6.735-29.849 17.431-39.766-11.454-9.658-26.213-15.505-42.278-15.505h-37.526c-10.55 0-20.541 2.518-29.402 6.982-25.559 12.88-39.288 41.365-34.553 69.593l34.183 203.801c4.957 52.023 30.857 93.103 84.04 93.471 14.444-.15 25.256-5.131 33-13.411-15.34-15.139-24.874-36.147-24.895-59.346z"
            fill="#fb2b3a"
          ></path>
          <g fill="#e41f2d">
            <path d="m134.653 406.828-34.183-203.8c-4.735-28.228 8.994-56.713 34.555-69.592 6.463-3.257 13.533-5.462 20.978-6.426-2.748-.354-5.541-.556-8.381-.556h-37.526c-10.55 0-20.541 2.518-29.402 6.982-25.56 12.879-39.289 41.364-34.554 69.592l34.183 203.801c4.957 52.023 30.857 93.103 84.04 93.471 9.189-.095 16.897-2.159 23.292-5.77-32.469-13.087-49.129-47.053-53.002-87.702z"></path>
            <path d="m431.305 133.436c-8.86-4.464-18.851-6.982-29.402-6.982h-37.526c-16.064 0-30.823 5.847-42.277 15.505 10.695 9.917 17.412 24.069 17.431 39.766l-8.461 63.026c-5.939 44.237-5.595 89.048 1.023 133.188l7.438 49.605c-.021 23.199-9.555 44.206-24.894 59.346 7.744 8.28 18.556 13.261 33 13.411 53.183-.369 79.082-41.448 84.04-93.471l34.183-203.801c4.735-28.229-8.994-56.714-34.555-69.593z"></path>
          </g>
        </g>
        <path
          d="m256 512c-46.492 0-84.532-38.039-84.532-84.531l7.449-49.679c6.602-44.033 6.946-88.777 1.022-132.906l-8.47-63.093c0-30.435 24.902-55.337 55.337-55.337h58.39c30.435 0 55.337 24.902 55.337 55.337l-8.47 63.093c-5.924 44.129-5.58 88.874 1.022 132.906l7.449 49.679c-.002 46.492-38.042 84.531-84.534 84.531z"
          fill="#fb2b3a"
        ></path>
        <path
          d="m225.459 427.469 7.449-49.679c6.602-44.033 6.946-88.777 1.022-132.906l-8.47-63.093c0-30.435 24.901-55.337 55.337-55.337h-53.991c-30.435 0-55.337 24.902-55.337 55.337l8.47 63.093c5.924 44.129 5.58 88.874-1.022 132.906l-7.449 49.679c.001 46.492 38.04 84.531 84.532 84.531 9.432 0 18.506-1.589 26.995-4.473-33.355-11.333-57.536-42.998-57.536-80.058z"
          fill="#e41f2d"
        ></path>
      </g>
    </svg>
  ),
  turnip: (props) => (
    <svg
      id="fi_6224791"
      enable-background="new 0 0 472.03 472.03"
      height="512"
      viewBox="0 0 472.03 472.03"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m73.489 472.03c-40.322 0-63.275-48.848-34.052-78.08l46.277-46.278c3.125-3.123 8.189-3.123 11.314 0 3.124 3.125 3.124 8.189 0 11.314l-46.277 46.277c-13.289 13.292-9.552 31.371.712 41.634 11.427 11.424 33.78 15.757 59.173-9.638 3.125-3.123 8.189-3.123 11.314 0 3.124 3.124 3.124 8.189 0 11.314-16.701 16.702-33.595 23.457-48.461 23.457z"
        fill="#ffebd2"
      ></path>
      <path
        d="m437.864 143.756c-15.24-15.61-35.69-21.6-57.52-20.1-.195.212-.401.418-.599.63 13.487-14.37 21.705-32.3 20.289-53.14-.94-13.89-11.51-24.47-25.41-25.41-20.81-1.414-38.728 6.786-53.096 20.257.2-.187.395-.382.596-.567 1.49-21.83-4.5-42.28-20.11-57.52-9.96-9.73-24.89-10.56-35.88-2.01-37.425 29.144-24.14 80.405-24.14 81.93.081.032.162.066.243.098-68.482-26.852-132.882-3.8-172.493 54.393-31.312 45.864-37.63 105.107-16.75 156.88 13.21 32.75 18.88 56.55 5.59 81.53-1.83 3.44 1.95 7.22 5.39 5.39 25.04-13.33 48.85-7.59 81.53 5.6 46.05 18.59 98.69 15.87 142.81-8.16 30.703-16.665 57.741-44.317 70.55-76.73 13.287-33.49 11.255-69.56-1.656-103.197 32.405 6.695 63.759.284 82.667-23.993 8.549-10.99 7.719-25.921-2.011-35.881z"
        fill="#ffebd2"
      ></path>
      <path
        d="m362.714 220.547c2.355 8.801-9.447 14.008-14.458 6.399-45.097-68.474-133.358-112.895-207.671-77.959-37.885 17.807-70.393 55.43-83.529 102.339-2.4 8.568-14.96 7.403-15.669-1.466-6.362-79.515 44.843-149.443 107.497-167.824 89.024-26.254 190.071 49.7 213.83 138.511z"
        fill="#fff3e4"
      ></path>
      <g fill="#ffd9ad">
        <path d="m362.195 297.354c-1.159 3.773-2.514 7.542-4.033 11.203-1.288 3.104-5.599 3.335-7.21.386-4.884-8.939-11.47-29.523-42.267-70.906-6.323-8.503 6.516-18.038 12.84-9.56 16.406 22.045 29.976 44.195 40.447 65.973.435.905.518 1.942.223 2.904z"></path>
        <path d="m209.284 137.937c-43.178-32.635-64.51-39.191-73.597-44.23-2.922-1.62-2.606-5.909.481-7.186 3.711-1.535 7.452-2.878 11.217-4.034.962-.295 2.001-.213 2.908.224 22.705 10.915 45.754 25.175 68.631 42.467 8.525 6.422-1.263 19.099-9.64 12.759z"></path>
        <path d="m299.939 376.596c-2.329 1.532-4.794 3.061-7.318 4.534-2.276 1.328-5.191.144-5.884-2.399-2.254-8.275-6.791-25.999-20.733-52.256-4.979-9.334 9.157-16.85 14.12-7.5 9.563 17.988 16.782 35.875 21.484 53.253.45 1.662-.231 3.422-1.669 4.368z"></path>
        <path d="m235.645 279.667c-4.849-6.298-9.936-12.491-15.119-18.408-6.968-7.954 5.054-18.512 12.035-10.543 5.405 6.17 10.708 12.626 15.762 19.191 6.511 8.457-6.269 18.087-12.678 9.76z"></path>
        <path d="m112.524 175.716c-23.496-11.832-38.968-15.777-46.503-17.798-2.545-.683-3.748-3.603-2.42-5.88 1.445-2.477 2.961-4.925 4.549-7.343.94-1.431 2.706-2.097 4.358-1.648 15.397 4.181 31.253 10.34 47.215 18.369 9.54 4.818 2.183 18.992-7.199 14.3z"></path>
        <path d="m163.524 322.406c-33.509-40.528-76.947-71.943-119.9-86.851-1.646-.571-2.762-2.123-2.713-3.865.084-2.998.248-5.992.491-8.984.2-2.468 2.558-4.162 4.963-3.571 22.38 5.494 83.318 37.238 129.499 93.071 6.784 8.232-5.617 18.277-12.34 10.2z"></path>
      </g>
      <path
        d="m437.864 143.756c-15.24-15.61-35.69-21.6-57.52-20.1-.195.212-.401.418-.599.63 13.487-14.37 21.705-32.3 20.289-53.14-.94-13.89-11.51-24.47-25.41-25.41-20.81-1.414-38.728 6.786-53.096 20.257.2-.187.395-.382.596-.567 1.49-21.83-4.5-42.28-20.11-57.52-9.96-9.73-24.89-10.56-35.88-2.01-37.425 29.144-24.14 80.405-24.14 81.93 50.64 19.754 95.387 64.226 115.2 115.8 32.41 6.7 63.77.29 82.68-23.99 8.55-10.989 7.72-25.92-2.01-35.88z"
        fill="#befa91"
      ></path>
      <path
        d="m439.874 179.636c-4.163 5.345-11.919 2.52-12.39-3.581-1.478-19.16-23.59-39.748-56.39-43.568 3.32-2.79 6.41-5.74 9.25-8.83 21.83-1.5 42.28 4.49 57.52 20.1 9.73 9.959 10.56 24.89 2.01 35.879z"
        fill="#daffbf"
      ></path>
      <path
        d="m389.586 137.153c-12.306 12.513-27.681 22.238-43.875 29.182-3.545 1.52-7.645.33-9.831-2.848-1.906-2.771-3.884-5.5-5.925-8.181 22.841-8.067 39.902-20.014 50.375-31.643.101-.049 3.118-.171 3.375-.18 7.238-.243 10.959 8.506 5.881 13.67z"
        fill="#9ceb63"
      ></path>
      <path
        d="m391.996 77.334c-20.34-7.004-57.259 2.899-81.31 45.773-1.866 3.326-6.321 4.136-9.174 1.605-3.562-3.159-7.223-6.198-10.977-9.105 13.57-38.47 43.28-72.64 84.09-69.87 13.688.926 24.51 11.273 25.427 25.668.273 4.291-3.991 7.329-8.056 5.929z"
        fill="#daffbf"
      ></path>
      <path
        d="m302.146 8.035c4.256 4.167 1.868 11.328-3.99 12.408-4.226.779-8.345 2.59-12.022 5.454-21.468 16.716-26.246 40.721-26.423 58.434-.052 5.258-5.504 8.703-10.312 6.575-2.451-1.085-4.92-2.112-7.405-3.079 0-1.53-13.28-52.79 24.14-81.93 10.756-8.369 25.674-7.983 36.012 2.138z"
        fill="#daffbf"
      ></path>
    </svg>
  ),
  cauliflower: (props) => (
    <svg
      viewBox="0 -57 511.99983 511"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_1135562"
      {...props}
    >
      <path
        d="m436.726562 156.609375c1.15625-4.902344 1.832032-9.992187 1.832032-15.246094 0-36.609375-29.679688-66.289062-66.289063-66.289062-.8125 0-1.597656.09375-2.402343.121093-7.097657-24.015624-29.285157-41.550781-55.601563-41.550781-1.863281 0-3.703125.105469-5.523437.277344-9.257813-19.726563-29.242188-33.421875-52.480469-33.421875-17.886719 0-33.871094 8.109375-44.511719 20.835938-6.726562-2.726563-14.066406-4.265626-21.777344-4.265626-29.222656 0-53.332031 21.636719-57.347656 49.75-.21875 0-.433594-.03125-.652344-.03125-36.609375 0-66.289062 29.675782-66.289062 66.285157 0 9.210937 1.882812 17.976562 5.277344 25.945312-22.90625 12.726563-38.421876 37.140625-38.421876 65.203125 0 41.1875 33.386719 74.574219 74.574219 74.574219l295.886719 3.566406c41.1875 0 76.988281-36.953125 76.988281-78.140625 0-29.988281-17.742187-55.769531-43.261719-67.613281zm0 0"
        fill="#fff6d8"
      ></path>
      <g fill="#ffedb1">
        <path d="m123.6875 199.363281c0-26.613281 16.570312-41.429687 27.550781-51.988281 3.789063-3.648438 4.824219-9.339844 3.058594-14.296875-3.699219-10.367187-5.75-21.507813-5.75-33.144531 0-34.578125 17.691406-64.992188 44.472656-82.785156-.015625-.0625.019531.066406 0 0-30.578125-1.5625-56.238281 20.585937-60.390625 49.671874-.222656 0-.433594-.03125-.65625-.03125-36.609375 0-66.289062 29.675782-66.289062 66.285157 0 9.210937 1.886718 17.976562 5.277344 25.945312-24.308594 13.503907-40.292969 40.175781-38.242188 70.394531 2.675781 39.5 35.441406 69.382813 75.03125 69.382813l118.585938 4.234375 46.5-4.234375c-99.433594 0-149.148438-49.714844-149.148438-99.433594zm0 0"></path>
        <path d="m243.261719 83.175781c-15.792969 9.378907-26.117188 25.835938-28.03125 43.890625-5.480469-1.457031-11.167969-2.277344-16.96875-2.277344-6.433594 0-12.800781.925782-18.9375 2.746094-4.382813 1.308594-6.882813 5.921875-5.582031 10.308594 1.3125 4.386719 5.898437 6.84375 10.308593 5.582031 4.597657-1.367187 9.378907-2.0625 14.210938-2.0625 16.238281 0 31.492187 7.960938 40.804687 21.304688 1.621094 2.308593 4.195313 3.546875 6.808594 3.546875 1.632812 0 3.292969-.488282 4.730469-1.492188 3.757812-2.621094 4.671875-7.789062 2.054687-11.539062-5.632812-8.066406-12.953125-14.5625-21.230468-19.355469-.003907-.25-.023438-.5-.023438-.75 0-14.550781 7.78125-28.21875 20.316406-35.664063 3.933594-2.328124 5.226563-7.417968 2.890625-11.351562-2.339843-3.933594-7.421875-5.234375-11.351562-2.886719zm0 0"></path>
        <path d="m366.710938 213.257812c-6.144532-5.871093-13.605469-9.761718-21.507813-11.789062 1-14.324219-4.320313-28.414062-14.816406-38.445312-5.195313-4.976563-11.265625-8.648438-18.039063-10.929688-4.363281-1.472656-9.039062.875-10.496094 5.203125-1.464843 4.335937.867188 9.039063 5.203126 10.492187 4.453124 1.507813 8.441406 3.925782 11.878906 7.210938 6.867187 6.566406 10.375 15.761719 9.78125 25.136719-5.855469.523437-11.667969 1.976562-17.125 4.675781-5.042969 2.5-9.597656 5.839844-13.53125 9.960938-3.171875 3.300781-3.058594 8.542968.25 11.707031 1.601562 1.546875 3.667968 2.304687 5.730468 2.304687 2.175782 0 4.351563-.855468 5.980469-2.554687 2.605469-2.71875 5.605469-4.929688 8.914063-6.5625 12.027344-5.964844 26.632812-3.714844 36.316406 5.566406 3.3125 3.164063 8.546875 3.035156 11.71875-.257813 3.164062-3.3125 3.042969-8.554687-.257812-11.71875zm0 0"></path>
        <path d="m200.234375 234.0625c-3.761719-.046875-7.417969-.734375-10.882813-2.046875-12.550781-4.742187-20.859374-16.945313-20.683593-30.359375.066406-4.582031-3.601563-8.335938-8.171875-8.398438-.039063 0-.082032 0-.113282 0-4.523437 0-8.222656 3.632813-8.285156 8.171876-.277344 20.375 12.339844 38.898437 31.394532 46.089843 5.277343 1.992188 10.828124 3.035157 16.515624 3.117188h.113282c4.523437 0 8.222656-3.636719 8.285156-8.175781.058594-4.578126-3.597656-8.332032-8.171875-8.398438zm0 0"></path>
      </g>
      <path
        d="m502.410156 245.796875c-39.191406 40.835937-114.859375 53.160156-176.300781 54.757813-2.1875.054687-4.101563 1.375-4.945313 3.394531l-13.066406 31.21875c-1.195312 2.859375.109375 6.132812 2.976563 7.300781 11.089843 4.527344 39.527343 14.332031 77.765625 14.332031 97.605468 0 118.628906-72.148437 123.109375-106.507812.695312-5.339844-5.808594-8.382813-9.539063-4.496094zm0 0"
        fill="#afdc82"
      ></path>
      <path
        d="m107.113281 290.511719c-29.761719 0-74.960937-19.90625-100.011719-48.089844-2.640624-2.972656-7.46875-.960937-7.0781245 2.996094 3.1171875 31.808593 21.1601565 111.382812 123.6640625 111.382812 24.859375 0 41.429688-8.285156 41.429688-8.285156zm0 0"
        fill="#96cd82"
      ></path>
      <path
        d="m210.152344 355.183594c6.167968 7.953125 12.394531 18.449218 17.59375 32.210937 2.445312 6.472657 8.589844 10.835938 15.507812 10.835938h26.011719c6.933594 0 13.074219-4.382813 15.527344-10.871094 8.023437-21.214844 20.785156-39.136719 29.707031-47.464844l-107.953125.332031zm0 0"
        fill="#afdc82"
      ></path>
      <path
        d="m239.230469 298.058594c-43.253907 5.292968-94.269531-5.984375-137.183594-53.925782-2.605469-2.910156-7.429687-.792968-6.976563 3.085938 4.5625 39.332031 28.617188 159.296875 152.90625 93.007812zm0 0"
        fill="#afdc82"
      ></path>
      <path
        d="m328.960938 253.847656c-15.027344 21.519532-61.308594 47.035156-114.121094 45.351563l2.800781 9.550781c6.421875 21.898438 23.050781 40.101562 45.082031 46.046875 7.300782 1.96875 14.894532 2.667969 22.652344 2.003906 39.308594-3.367187 49.890625-64.621093 52.722656-99.859375.414063-5.171875-6.164062-7.347656-9.136718-3.09375zm0 0"
        fill="#cde682"
      ></path>
    </svg>
  ),
  'green-pepper': (props) => (
    <svg
      id="fi_2909814"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m262.53 115.53h.01c5.33 10.5 17.79 12.76 30.07 11.98a113.369 113.369 0 0 0 30.92-7c-17.23 21.94-4.95 39.08-4.95 39.08a64.512 64.512 0 0 0 -20.38-3.18c-17.32 0-33.74 13.46-47.66 12.2-15.79-1.44-22.54-17.42-46.55-20.87 20.43-8.05 16.59-41.81 3.47-66.86-9.22-17.62-23.04-30.93-36.24-27.96 0 0-14.33 13.62-21.52-12.26-2.85-10.26-2.68-17.25-1.64-21.83a10.055 10.055 0 0 1 9.81-7.83c36.6.19 65.45 30.67 84.8 63.09h.01a259.114 259.114 0 0 1 19.85 41.44z"
        fill="#8fba39"
      ></path>
      <path
        d="m323.53 120.51a113.369 113.369 0 0 1 -30.92 7c-12.28.78-24.74-1.48-30.07-11.98h-.01a259.114 259.114 0 0 0 -19.85-41.44h-.01c-19.35-32.42-48.2-62.9-84.8-63.09a10.055 10.055 0 0 0 -9.81 7.83 26.993 26.993 0 0 0 -.523 3.288c33.38 3.642 59.858 32.319 77.991 62.7h.01a259.114 259.114 0 0 1 19.85 41.44h.01c5.331 10.5 17.79 12.76 30.07 11.98a113.369 113.369 0 0 0 30.92-7c-7.61 9.689-9.459 18.439-9.158 25.193.324-.009.647-.023.97-.023a64.512 64.512 0 0 1 20.38 3.18s-12.28-17.138 4.95-39.078z"
        fill="#667f29"
      ></path>
      <path
        d="m181.34 473.75c-44.81 5.17-85.43-65.08-103.79-156.84-18.44-92.2-38.6-169.82 37.34-188.59a32.091 32.091 0 0 1 8.74-.78c15.44.44 37.38 9.01 50.72 25.41-22.37 14.36-31.85 52.23-35.2 81.05-3.32 28.58-2.53 52.79-2.53 86.07 0 69.12 20.37 128.11 44.72 153.68z"
        fill="#136b0a"
      ></path>
      <path
        d="m181.34 473.75c-24.35-25.57-44.72-84.56-44.72-153.68 0-33.28-.79-57.49 2.53-86.07 3.35-28.82 12.83-66.69 35.2-81.05a36.4 36.4 0 0 1 20.07-5.86 67.083 67.083 0 0 1 9.57.65c24.01 3.45 30.76 19.43 46.55 20.87 13.92 1.26 30.34-12.2 47.66-12.2a64.512 64.512 0 0 1 20.38 3.18 63.042 63.042 0 0 1 26.89 17.88c25.74 28.27 43.46 66.24 22.45 154.06-4.75 19.89-24.7 61.95-30.89 78.41-12.16 32.35-17.84 56.86-27.15 72.26-7.44 12.32-17.2 18.8-34.45 18.8-14.59 0-22.71-11.98-39.24-14.27-13.67-1.89-17.28.62-29.14.61-8.6-.01-17.39-4.85-25.71-13.59z"
        fill="#078407"
      ></path>
      <g opacity=".6">
        <path
          d="m172.664 305.714c-29.049-66.965-57.488-127.651-60.455-176.685-72.763 19.934-52.877 96.788-34.659 187.881 18.36 91.76 58.98 162.01 103.79 156.84 8.32 8.74 17.11 13.58 25.71 13.59 11.86.01 15.47-2.5 29.14-.61 16.53 2.29 24.65 14.27 39.24 14.27 16.148 0 25.732-5.68 32.994-16.512-47.655-23.588-98.011-91.774-135.76-178.774z"
          fill="#45a534"
        ></path>
      </g>
      <path
        d="m417.06 129.88c52.03 13.48 34.37 103.55 16.05 195.21-14.12 70.59-32.29 132.23-76.2 151.77-17.29 7.7-34.6 6.97-47.03 5.34 9.31-15.4 14.99-39.91 27.15-72.26 6.19-16.46 26.14-58.52 30.89-78.41 21.01-87.82 3.29-125.79-22.45-154.06a63.042 63.042 0 0 0 -26.89-17.88c16.15-19.86 82.97-33.41 97.56-29.94.31.07.62.15.92.23z"
        fill="#136b0a"
      ></path>
      <path
        d="m417.14 129.55-.08.33c-.3-.08-.61-.16-.92-.23-14.59-3.47-81.41 10.08-97.56 29.94 0 0-12.28-17.14 4.95-39.08a113.369 113.369 0 0 1 -30.92 7v-.01c1.12-7.92 6.66-15.92 14.84-22.63 13.98-11.45 35.65-19.13 56.17-16.22 29.33 4.17 51.64 21.76 53.52 40.9z"
        fill="#078407"
      ></path>
      <path
        d="m306.3 104.33 1.15.54c-8.18 6.71-13.72 14.71-14.84 22.63v.01c-12.28.78-24.74-1.48-30.07-11.98h-.01a259.114 259.114 0 0 0 -19.85-41.44c23.23-2.32 51.31 1.15 63.62 30.24z"
        fill="#147f09"
      ></path>
      <path
        d="m207.46 80.88c13.12 25.05 16.96 58.81-3.47 66.86a67.083 67.083 0 0 0 -9.57-.65 36.4 36.4 0 0 0 -20.07 5.86c-13.34-16.4-35.28-24.97-50.72-25.41v-.04c8.74-26.6 43.71-37.79 83.83-46.62z"
        fill="#078407"
      ></path>
      <g opacity=".6">
        <path
          d="m173.774 345.67a6 6 0 0 1 -5.984-5.664c-.371-6.611-.56-13.318-.56-19.936 0-5.535-.021-10.82-.042-15.917-.031-7.421-.06-14.431-.018-21.25a6 6 0 0 1 6-5.963h.038a6 6 0 0 1 5.963 6.037c-.042 6.757-.013 13.737.018 21.127.021 5.112.042 10.414.042 15.966 0 6.394.182 12.876.541 19.263a6 6 0 0 1 -5.655 6.328q-.172.009-.343.009z"
          fill="#e9e9e9"
        ></path>
      </g>
    </svg>
  ),
  betravet: (props) => (
    <svg
      id="fi_5194813"
      enable-background="new 0 0 450 450"
      height="512"
      viewBox="0 0 450 450"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-rule="evenodd" fill-rule="evenodd">
        <path
          d="m258.716 67.924h14.049l.766 20.69c9.195-14.049 18.902-27.842 24.266-36.526 4.342 2.81 8.429 5.619 12.771 8.429-13.282 22.222-24.01 45.466-35.249 68.71-1.533 1.533 15.837-9.706 20.69-13.027l43.167-80.46c3.831 1.533 5.875 2.554 9.706 4.087l-17.114 48.02c12.516-10.728 25.032-22.478 40.358-35.76 4.087 5.109 7.918 8.94 11.494 12.516-25.287 26.054-49.808 47.51-70.243 73.819l69.476-43.934 3.831 13.282-56.45 52.363c30.907-5.364 44.955-14.559 92.209-34.227.766 4.342 1.788 11.75 2.554 16.092-21.201 8.94-45.466 18.391-69.476 27.586 14.049.255 30.651.255 43.167.511v12.516c-33.716.511-69.476 15.07-93.487 17.114-2.043-1.022-37.548-54.917-59.77-65.39 3.831-3.576 8.174-14.049 13.538-22.989z"
          fill="#83b03a"
        ></path>
        <path
          d="m384.132 98.575 2.554 9.195-56.45 52.363c30.907-5.364 44.955-14.559 92.209-34.227.766 4.342 1.788 11.75 2.554 16.092-21.201 8.94-45.466 18.391-69.476 27.586 14.049.255 30.651.255 43.167.511v12.516c-33.716.511-69.476 15.07-93.487 17.114-6.897-3.831-9.195-17.88-10.217-24.776z"
          fill="#729b2d"
        ></path>
        <path
          d="m25 376.481c5.875 4.853 20.179 14.304 64.879-19.668 9.962-7.663 22.222 2.043 41.379 8.429 113.921 38.314 210.728-31.673 185.951-153.512-12.771-36.782-60.026-77.65-97.573-94.253-61.047-26.82-133.844 11.494-149.17 75.351-9.962 41.379 4.853 84.291 13.538 113.155 8.94 29.119-22.222 59.259-59.004 70.498z"
          fill="#8e2d44"
        ></path>
        <path
          d="m25 376.481c5.875 4.853 20.179 14.304 64.879-19.668 9.962-7.663 22.222 2.043 41.379 8.429 113.921 38.314 210.728-31.673 185.951-153.512-4.087-12.261-12.261-24.777-22.222-36.782-77.905 87.101-158.365 122.605-210.217 134.1 5.875 28.097-24.266 56.45-59.77 67.433z"
          fill="#7f253a"
        ></path>
        <path
          d="m152.203 342.254c18.902 29.374 51.341 65.9 95.019 71.264 44.189 5.109 117.241-15.581 141.507-80.46 16.603-45.211-7.407-96.296-41.89-128.225-65.9 45.978-128.991 91.444-194.636 137.421z"
          fill="#a43852"
        ></path>
        <path
          d="m353.225 212.241c19.157 29.885-1.533 88.889-53.384 125.926-52.107 36.782-128.48 33.972-147.637 4.087s7.663-84.036 59.515-121.073c52.106-36.782 122.349-38.825 141.506-8.94z"
          fill="#b34760"
        ></path>
        <path
          d="m322.573 232.675c13.027 20.69-1.022 61.558-37.037 87.101s-89.144 23.499-102.427 2.81c-13.027-20.69 5.364-58.238 41.379-83.78 36.016-25.543 84.803-26.821 98.085-6.131z"
          fill="#bf516b"
        ></path>
        <path
          d="m291.922 252.854c7.407 11.494-.511 34.483-20.69 48.787s-49.808 13.282-57.216 1.533c-7.407-11.494 2.81-32.695 22.989-46.999s47.51-15.071 54.917-3.321z"
          fill="#d66782"
        ></path>
        <path
          d="m161.654 125.906c16.858-3.831 32.184.766 34.483 10.473 2.299 9.451-9.706 20.179-26.564 24.01-16.603 3.831-32.184-.766-34.483-10.473-2.044-9.45 9.706-20.178 26.564-24.01z"
          fill="#b34760"
        ></path>
      </g>
    </svg>
  ),
  'tomate-cerise': (props) => (
    <svg
      id="fi_4977391"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      {...props}
    >
      <path
        d="m195.28 376.95-16.49-40.64-17.11-33.9-.01-.01a82.528 82.528 0 0 1 -92.81 24.03 82.376 82.376 0 0 0 108.04 123.54c16.21-11.8 27.08-27.21 31.62-45.22v-.01z"
        fill="#de3c44"
      ></path>
      <path
        d="m91.71 431.92a82.247 82.247 0 0 1 2.431-100.141 82.307 82.307 0 0 1 -25.281-5.349 82.344 82.344 0 0 0 74.589 137.948 82.168 82.168 0 0 1 -51.739-32.458z"
        fill="#b7303d"
      ></path>
      <path
        d="m452.93 273.1a88.32 88.32 0 0 0 -23.5-8.84 75.732 75.732 0 0 0 -30.98-.29l-19.48 23.86-29.71 32.29h-.01l-19.66 28.77c1.47 27.62 18.44 54.65 44.56 68.83a82.343 82.343 0 1 0 78.78-144.62z"
        fill="#e75163"
      ></path>
      <path
        d="m428.41 111.83c-18.56-7.59-37.41-8.73-55.15-3.13l-16.74 25.84-26 35.36-16.39 30.74c3.96 24.14 20.6 46.81 43.27 59.43l41.05 3.9a75.732 75.732 0 0 1 30.98.29 85.3 85.3 0 0 0 44.06-45.08 82.254 82.254 0 0 0 -45.08-107.35z"
        fill="#de3c44"
      ></path>
      <path
        d="m307.93 351.56-2.26-6.54v-.01c-7.19-19.51-15.52-44.72-23.18-74.35q-2.355-9.09-4.6-18.71a754.422 754.422 0 0 1 -19.22-137.8q-.285-6.3-.44-12.68c-.44-17.52-.23-35.51.8-53.84l-29.31-1.39s.2 31.81 3.96 77.98v.01c.44 5.4.92 11.01 1.47 16.78v.01c4.06 43.3 11.17 96.11 23.59 146.57v.01q2.55 10.335 5.39 20.51c9.83 35.05 22.47 68.12 38.71 95.03l21.4-13.04s-7.53-16.03-16.31-38.54z"
        fill="#739937"
      ></path>
      <path
        d="m161.45 226.13-26.41-35.05-24.76-24.54c-27.47-3.58-57.17 8.17-75.89 31.23a82.386 82.386 0 0 0 127.28 104.63c.29-.33.57-.66.84-1a89.019 89.019 0 0 0 11.56-18.25 75.821 75.821 0 0 0 7.34-33.56z"
        fill="#e75163"
      ></path>
      <g fill="#4a6d24">
        <path d="m258.74 287.6q2.55 10.335 5.39 20.51c-11.33 13.67-38.17 38.84-38.17 38.84a26.7 26.7 0 0 0 -7.65-5.89s1.31-4.86-1.57-11.15c.5-.44 32.48-29.16 42-42.31z"></path>
        <path d="m338.66 273.01a26.611 26.611 0 0 0 -2.05 9.42s-4.96.9-9.4 6.21c-.44-.23-28.76-15.03-44.72-17.98q-2.355-9.09-4.6-18.71c17.22 4.36 60.77 21.06 60.77 21.06z"></path>
        <path d="m314.82 124.22a26.678 26.678 0 0 0 -1 9.59s-4.82 1.43-8.67 7.19c-.46-.39-30.27-25.6-46.48-26.85q-.285-6.3-.44-12.68c17.62 2.49 56.59 22.75 56.59 22.75z"></path>
        <path d="m235.15 141.01v.01c-7.45 16.12-51.78 48.23-51.78 48.23a26.8 26.8 0 0 0 -8.91-3.73c0-.09-.02-5.08-4.39-10.36.89-.55 57.79-35.77 63.61-50.93.44 5.4.92 11.01 1.47 16.78z"></path>
      </g>
      <path
        d="m195.28 376.95c-13.95 2.24-28.31-6.45-28.31-6.45 10.62-5.9 11.82-34.19 11.82-34.19a37.245 37.245 0 0 1 -12.06-9.14c-5.72-8.25-6.45-16.98-5.05-24.76l-.01-.01c.29-.33.57-.66.84-1a89.019 89.019 0 0 0 11.56-18.25c1.34 5.34 4.13 13.88 9.3 20.05 16.62 19.85 20.31 8.04 30.9 22.54a24.169 24.169 0 0 1 2.47 4.17c2.88 6.29 1.57 11.15 1.57 11.15a26.7 26.7 0 0 1 7.65 5.89 22.63 22.63 0 0 1 5.95 12.86c.84 7.47-10.08 22.36-7.83 27.56 6.2 14.35 19.41 24.52 19.41 24.52s-20.7 2.83-34.97-7.15c-7.37-5.14-13.02-13.69-13.24-27.79z"
        fill="#436f1e"
      ></path>
      <path
        d="m378.97 287.83c8.01 11.63 6.3 28.3 6.3 28.3-9.9-7.06-36.01 3.99-36.01 3.99h-.01a37.018 37.018 0 0 1 -3.1 14.8 31.5 31.5 0 0 1 -16.56 13.97c-7.64 2.91-15.73 3.11-21.66 2.67a55.784 55.784 0 0 1 -8.82-1.32 66.749 66.749 0 0 0 6.56-5.22v-.01c4.02-3.62 8.9-8.85 11.66-14.83 10.84-23.5-1.43-21.77 7.16-37.54a24.47 24.47 0 0 1 2.72-4c4.44-5.31 9.4-6.21 9.4-6.21a26.611 26.611 0 0 1 2.05-9.42 22.762 22.762 0 0 1 9.09-10.88c2.19-1.35 5.75-1.84 9.65-2.06 7.48-.43 16.19.11 18.65-2.69 10.33-11.75 13.87-28.02 13.87-28.02s11.44 17.46 8.53 34.61c-1.5 8.85-6.81 17.61-19.48 23.86z"
        fill="#436f1e"
      ></path>
      <path
        d="m356.52 134.54c9.23 10.69 9.36 27.45 9.36 27.45-10.61-5.93-35.36 7.91-35.36 7.91a37.089 37.089 0 0 1 -1.46 15.04 31.491 31.491 0 0 1 -14.93 15.7c-13.73 7.04-30.15 4.68-30.15 4.68s11.94-10.04 15.91-21.93c8.2-24.55-3.81-21.49 3-38.1a24.172 24.172 0 0 1 2.26-4.29c3.85-5.76 8.67-7.19 8.67-7.19a26.678 26.678 0 0 1 1-9.59 22.733 22.733 0 0 1 7.85-11.8c5.92-4.64 24.36-3.18 27.61-7.82 8.97-12.8 10.7-29.36 10.7-29.36s13.29 16.1 12.28 33.46c-.51 8.96-4.84 18.25-16.74 25.84z"
        fill="#739937"
      ></path>
      <path
        d="m135.04 191.08a37.259 37.259 0 0 1 -14-5.73 31.405 31.405 0 0 1 -10.76-18.81c-2.78-15.15 4.21-30.16 4.21-30.16s6.19 14.3 16.45 21.53c21.18 14.92 21.7 2.55 35.67 13.85a24.319 24.319 0 0 1 3.46 3.4c4.37 5.28 4.39 10.27 4.39 10.36a26.8 26.8 0 0 1 8.91 3.73 22.8 22.8 0 0 1 9.07 10.9c2.73 7-3.99 24.2-.47 28.65 9.69 12.27 25.08 18.7 25.08 18.7s-19.28 8.05-35.64 2.09c-8.44-3.08-16.11-9.89-19.96-23.46-12.91 5.73-29.02 1.03-29.02 1.03 8.75-8.43 2.61-36.08 2.61-36.08z"
        fill="#739937"
      ></path>
      <path
        d="m98.86 326.43a82.335 82.335 0 0 1 -34.47-128.66 87.053 87.053 0 0 1 47.451-29.682l-1.561-1.548c-27.47-3.58-57.17 8.17-75.89 31.23a82.327 82.327 0 0 0 79.027 132.746 82.023 82.023 0 0 1 -14.557-4.086z"
        fill="#bf4358"
      ></path>
      <path
        d="m152.43 227.16c8.75-8.43 2.61-36.08 2.61-36.08a37.259 37.259 0 0 1 -14-5.73 31.405 31.405 0 0 1 -10.76-18.81 42.669 42.669 0 0 1 -.6-9.577c-9.5-7.459-15.186-20.583-15.186-20.583s-6.99 15.01-4.21 30.16a31.405 31.405 0 0 0 10.76 18.81 37.259 37.259 0 0 0 14 5.73s6.14 27.65-2.61 36.08c0 0 11.927 3.474 23.48.8-2.173-.418-3.484-.8-3.484-.8z"
        fill="#5d772c"
      ></path>
    </svg>
  ),
};
